// Gerado por scripts/knowledge/build.mjs. Edite docs/nash/procedimentos/*.md.
export const RAW_MANUAL_SECTIONS = [
  {
    "id": "platform-overview",
    "title": "Navegação e nomes oficiais dos módulos",
    "category": "Início",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Menu lateral do Dashboard",
    "order": 0,
    "aliases": [
      "onde fica",
      "menu lateral",
      "mapa dos módulos",
      "navegação"
    ],
    "questions": [
      "Onde encontro as telas do sistema?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "O Dashboard organiza os módulos em abas internas. Os itens exibidos dependem das permissões e das condições da conta.",
    "whenToUse": [],
    "prerequisites": [
      "Estar autenticado e ter acesso ao módulo desejado."
    ],
    "steps": [
      "No menu lateral, procure Dashboard, Mural, Cadastros BPM, Gestão de Alunos, Gestão de Atendidos, Minha Agenda ou Cursos.",
      "Expanda “Studio” para Banco de Projetos, Formulários e Processos.",
      "Expanda “Meu Negócio” para Assinaturas, Arquivos, CRM, Dados Cadastrais, Clientes, Gerenciador NFS, Documentação, Documentos IA, Estoque, Financeiro, Organograma, Patrimônio e Recursos Humanos, conforme acesso.",
      "Expanda “Configurações” para Integrações, Minhas solicitações, Minha equipe, Grupo/Permissões, Usuários, Auditoria, Manual do usuário, Meu Perfil, Lixeira e Suporte Técnico, conforme acesso.",
      "Clique no item desejado para abrir sua aba interna."
    ],
    "rules": [
      "Os nomes das telas não são URLs. A navegação principal acontece em abas do Dashboard.",
      "“Minha equipe” exige a permissão de menu correspondente.",
      "“Endereços bloqueados” é um item específico da conta master.",
      "Cadastros BPM pode ter páginas dinâmicas com nomes definidos na instalação.",
      "Quando o modo Jovem Aprendiz estiver habilitado, o grupo “Gestão de Aprendiz” reúne Dashboard, Atendidos, Empresas, Registro de Faltas, Nota Fatura, Relatórios, FP - Aprendizes e Cadastros, conforme as permissões de cada item.",
      "A existência de um módulo no código não concede à conta acesso aos seus dados ou ações."
    ],
    "expectedResult": "A aba do módulo autorizado aparece no Dashboard.",
    "errors": [
      "Se um item não aparecer, confira com a administração as permissões e as condições de exibição; não invente outro caminho."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "request-lifecycle",
    "title": "Ciclo completo de uma solicitação",
    "category": "Início",
    "audience": "Todos",
    "journeyStage": "Início rápido",
    "accessPath": "Dashboard/Minhas solicitações → Nova solicitação e acompanhamento",
    "order": 1,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Veja como abrir, acompanhar, colaborar e finalizar solicitações utilizando os módulos de Solicitações e o Process Runner.",
    "whenToUse": [
      "Mapear o fluxo padrão antes de treinar equipes ou revisar SLAs de atendimento.",
      "Entender onde localizar históricos, anexos e comprovantes depois da conclusão do processo."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "No Dashboard ou em Solicitações, clique em “Nova solicitação” e escolha o processo publicado que deseja iniciar.",
      "Preencha o formulário da etapa inicial e envie para liberar a fase seguinte; use comentários ou eventos para registrar observações relevantes.",
      "Monitore prazos pela Caixa de solicitações aplicando filtros por status, responsável ou processo para assumir tarefas pendentes.",
      "Quando houver necessidade de intervenção, abra o Process Runner para reatribuir responsáveis, reabrir etapas ou avançar manualmente conforme permissões.",
      "Após a conclusão, utilize a aba Concluídas para exportar relatórios, baixar PDFs e revisar toda a linha do tempo."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Registre eventos sempre que ajustar dados manualmente para manter a trilha de auditoria completa.",
      "Combine filtros por período e processo com a exportação em Excel para produzir relatórios de acompanhamento ou compliance."
    ],
    "related": [
      "Caixa de solicitações",
      "Detalhamento e colaboração na solicitação",
      "Execução guiada de processos"
    ]
  },
  {
    "id": "login-access",
    "title": "Acesso ao sistema",
    "category": "Início",
    "audience": "Todos",
    "journeyStage": "Operação",
    "accessPath": "Tela de login",
    "order": 2,
    "aliases": [
      "login",
      "entrar",
      "lembrar usuário",
      "autenticador",
      "MFA",
      "esqueci a senha"
    ],
    "questions": [
      "Como entrar com CPF?",
      "O sistema salva minha senha?",
      "Como usar um código de recuperação?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Entre com e-mail ou CPF e senha. Quando solicitado, conclua a autenticação com o aplicativo autenticador ou código de recuperação.",
    "whenToUse": [],
    "prerequisites": [
      "Ter uma conta cadastrada e credenciais válidas."
    ],
    "steps": [
      "Na tela de login, informe seu e-mail ou CPF e sua senha.",
      "Se quiser guardar apenas o identificador neste navegador, marque “Lembrar usuário”.",
      "Clique em “Entrar”.",
      "Se aparecer a etapa do autenticador, informe o código atual do aplicativo ou um código de recuperação. No primeiro cadastro do autenticador, siga a configuração apresentada.",
      "Se forem apresentados códigos de recuperação, guarde-os em local seguro e conclua a etapa para entrar no Dashboard."
    ],
    "rules": [
      "“Lembrar usuário” guarda somente o identificador no navegador; a senha não é persistida.",
      "Desmarcar “Lembrar usuário” remove o identificador lembrado.",
      "O código de autenticação deve ser preenchido quando a conta exigir MFA; ele não substitui a senha no formulário inicial."
    ],
    "expectedResult": "Acesso ao Dashboard após concluir as etapas de autenticação exigidas para a conta.",
    "errors": [
      "“Informe o usuário e a senha.”: preencha ambos os campos.",
      "“Informe o código do autenticador ou um código de recuperação.”: preencha o código na etapa de MFA.",
      "Se o retorno informar um prazo para nova tentativa, aguarde o tempo exibido antes de tentar novamente."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "manual-how-to-use",
    "title": "Como usar este manual",
    "category": "Início",
    "audience": "Todos",
    "journeyStage": "Início rápido",
    "accessPath": "Configurações → Manual do usuário",
    "order": 3,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Aprenda a navegar no manual por busca, filtros, categorias e assistente para encontrar respostas sem depender de suporte.",
    "whenToUse": [
      "Localizar rapidamente um procedimento específico dentro da plataforma.",
      "Treinar usuários por perfil, módulo ou etapa da jornada de trabalho."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Use o campo de pesquisa para buscar nomes de módulos, ações ou palavras do processo, como aluno, orçamento, anexo, PDF, turma ou permissão.",
      "Filtre por categoria para reduzir a lista a Início, Operações, Automação, Administração, Financeiro, Cadastros, Pessoas, Projetos, Alunos, Cursos ou Vendas.",
      "Abra uma seção e leia primeiro Resumo e Quando usar; depois siga os Passos e consulte Dicas antes de executar ações irreversíveis.",
      "Clique nas seções relacionadas para continuar a jornada quando uma tarefa depender de outro módulo, como Usuários, Auditoria, Arquivos ou E-mail.",
      "Faça uma pergunta ao assistente do manual em linguagem natural; ele cruza o texto das seções e sugere os conteúdos mais relevantes."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Pesquise pelo resultado desejado, não apenas pelo nome da tela: por exemplo, “prestação de contas” encontra Banco de Projetos e relatórios.",
      "Para treinamento, percorra as categorias na ordem Início → Operações → módulos de negócio → Administração."
    ],
    "related": [
      "Visão geral da plataforma",
      "Painel inicial e navegação",
      "Nash Chat e assistente da plataforma"
    ]
  },
  {
    "id": "home-dashboard",
    "title": "Painel inicial e navegação",
    "category": "Início",
    "audience": "Todos",
    "journeyStage": "Início rápido",
    "accessPath": "Dashboard",
    "order": 4,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Conheça o painel inicial, acompanhe indicadores operacionais, acesse notificações e organize módulos em abas durante a sessão.",
    "whenToUse": [
      "Mapear rapidamente o status das solicitações e processos ao iniciar o dia.",
      "Abrir diferentes módulos em paralelo sem perder o contexto de trabalho."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Revise os cartões de destaque para verificar solicitações abertas, pendências da equipe e SLAs próximos do vencimento.",
      "Utilize o menu lateral para alternar entre modo compacto e expandido, pesquisar itens pelo nome e acionar o atalho “Nova solicitação”.",
      "Abra o sino de notificações para conferir solicitações recém-atribuídas; ao visualizar um item ele é marcado automaticamente como lido.",
      "Clique em qualquer item do menu para carregar o módulo em uma nova aba interna. Feche abas com o botão × quando concluir a atividade."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "No celular, use o botão de menu para exibir a navegação completa sem sair da tela atual.",
      "Filtros e buscas aplicados em uma aba permanecem válidos enquanto ela estiver aberta, facilitando comparações lado a lado."
    ],
    "related": [
      "Perfil",
      "Solicitações",
      "Agenda"
    ]
  },
  {
    "id": "notice-board",
    "title": "Mural de comunicados",
    "category": "Comunicação",
    "audience": "Todos",
    "journeyStage": "Execução diária",
    "accessPath": "Mural",
    "attention": "A criação, edição e exclusão de comunicados dependem de permissão; usuários sem acesso de gestão apenas consultam avisos liberados para seu público.",
    "order": 6,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Consulte avisos internos e publique comunicados segmentados com prioridade, data de evento, imagem de capa, anexos e público-alvo.",
    "whenToUse": [
      "Divulgar comunicados institucionais, eventos, alertas ou orientações para grupos, setores ou usuários específicos.",
      "Encontrar rapidamente avisos ativos sem abrir e-mails ou conversas individuais."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Mural no menu lateral e use a busca para encontrar avisos por título, conteúdo, prioridade ou anexos.",
      "Leia os cartões em destaque observando prioridade, autor, data de evento, mensagem formatada, imagem de capa e arquivos anexos.",
      "Se possuir permissão, clique em “Novo comunicado” para informar título, prioridade, data do evento e conteúdo no editor rico.",
      "Escolha o público por grupos, setores ou usuários; deixe sem segmentação somente quando o aviso puder ser visto por todos.",
      "Adicione capa e anexos quando necessário, salve e acompanhe o aviso publicado no próprio mural.",
      "Edite comunicados quando houver correções e exclua apenas publicações que não devem permanecer no histórico operacional."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Use prioridades altas para alertas que exigem ação imediata e mantenha títulos objetivos para facilitar a busca posterior.",
      "Segmentar o público evita excesso de informação para equipes que não participam do assunto."
    ],
    "related": [
      "Agenda colaborativa",
      "Nash Chat e assistente da plataforma",
      "Gestão de usuários"
    ]
  },
  {
    "id": "requests-inbox",
    "title": "Caixa de solicitações",
    "category": "Operações",
    "audience": "Colaboradores",
    "journeyStage": "Execução diária",
    "accessPath": "Minhas solicitações",
    "order": 8,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Monitore solicitações em andamento com filtros rápidos, indicadores de SLA e abertura direta das tarefas em abas dedicadas.",
    "whenToUse": [
      "Executar demandas que dependem da sua aprovação ou atuação diária.",
      "Repriorizar solicitações pendentes com base em prazo, processo ou responsável."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse o módulo Solicitações para visualizar os cartões de volume (abertas, pendentes da equipe, em atraso e concluídas).",
      "Utilize o seletor de Usuário e os botões de atalho (“Solicitações do usuário” ou “Resolvidas pelo usuário”) para focar em um colaborador específico quando necessário.",
      "Refine a lista com a busca por texto, filtros por processo e prazo e, se necessário, abra os Filtros avançados para definir solicitante, responsável e período.",
      "Use Nova solicitação, Atualizar e Exportar quando necessário. Para tratar uma tarefa, clique na linha ou em “Abrir solicitação”."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O botão “Limpar filtros” zera rapidamente busca, prazos e filtros avançados quando você precisar iniciar uma nova consulta.",
      "Os relatórios “Exportar por processo” e “Relatório completo” geram arquivos prontos para auditoria e compartilhamento com outras áreas."
    ],
    "related": [
      "Solicitações concluídas",
      "Processos",
      "Agenda"
    ]
  },
  {
    "id": "requests-completed",
    "title": "Solicitações concluídas",
    "category": "Operações",
    "audience": "Colaboradores",
    "journeyStage": "Execução diária",
    "accessPath": "Minhas solicitações → Concluídas",
    "order": 9,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Consulte histórico completo, formulários e anexos de solicitações finalizadas e gere relatórios personalizados.",
    "whenToUse": [
      "Resgatar decisões para auditorias internas ou externas.",
      "Conferir produtividade por processo, período ou responsável."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "No módulo Solicitações, selecione o filtro “Concluídas” para exibir apenas execuções finalizadas.",
      "Defina período, processo e participantes pelos filtros rápidos ou pelo painel de Filtros avançados.",
      "Use o botão “Histórico” em cada linha para expandir a linha do tempo das etapas ou abra a visão detalhada para baixar o PDF da solicitação.",
      "Gere planilhas com “Exportar Excel”, “Exportar por processo” ou “Relatório completo” respeitando os filtros aplicados."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "A visão detalhada mantém os formulários preenchidos agrupados por seção, facilitando conferências ponto a ponto.",
      "Combine exportações filtradas com os registros da Auditoria do sistema para mapear quem executou cada ação."
    ],
    "related": [
      "Auditoria",
      "Solicitações",
      "Processos"
    ]
  },
  {
    "id": "request-detail",
    "title": "Detalhamento e colaboração na solicitação",
    "category": "Operações",
    "audience": "Colaboradores",
    "journeyStage": "Execução diária",
    "accessPath": "Minhas solicitações → Abrir solicitação",
    "order": 10,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Execute a etapa atual preenchendo o formulário, anexando arquivos, registrando eventos e enviando a tarefa para o próximo responsável.",
    "whenToUse": [
      "Complementar dados ou anexos solicitados na etapa em execução.",
      "Assumir uma tarefa pendente, registrar um evento manual ou finalizar o fluxo."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra a solicitação na aba dedicada e revise o cabeçalho com processo, solicitante, prazo e status.",
      "Clique em “Assumir tarefa” quando disponível para liberar o envio do formulário ou utilize “Liberar” caso precise devolver a responsabilidade.",
      "Preencha os campos organizados por grupos, anexando arquivos nos campos do tipo upload; o sistema valida obrigatórios e mantém rascunhos locais por etapa.",
      "Se houver eventos pendentes, use “Registrar evento” antes de enviar. Finalize com o botão “Enviar” para avançar o fluxo ou concluir o processo.",
      "Utilize o botão “Baixar PDF” para gerar um resumo assinado da solicitação quando necessário."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Os rascunhos ficam salvos no navegador até que a etapa seja enviada, permitindo retomar o preenchimento depois.",
      "Campos bloqueados indicam dados herdados de etapas anteriores e ajudam a manter a rastreabilidade das informações."
    ],
    "related": [
      "Solicitações",
      "Arquivos",
      "Automação"
    ]
  },
  {
    "id": "processes-catalog",
    "title": "Catálogo de processos",
    "category": "Operações",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Studio → Processos",
    "order": 12,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Gerencie o catálogo de processos, aplique filtros por status, utilize a IA para analisar fluxos e acione integrações ou exportações.",
    "whenToUse": [
      "Controlar versões publicadas e rascunhos antes de liberar um fluxo para a operação.",
      "Identificar processos com maior adoção ou necessidade de integração externa."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Processos para visualizar os indicadores de volume total, publicados e rascunhos.",
      "Use os filtros de status, categoria, período e busca textual para encontrar rapidamente o fluxo desejado.",
      "Acione os botões de ação de cada cartão para editar, exportar pacotes, abrir as configurações de integração ou analisar o processo com o Assistente IA.",
      "Crie novos processos pelo botão “Novo processo”, importe pacotes existentes ou gere fluxos sugeridos com o botão “Assistente IA”."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O selo de status no canto superior direito do cartão indica se o fluxo está publicado ou em rascunho.",
      "Use “Exportar por processo” para gerar backups individuais antes de alterações estruturais importantes."
    ],
    "related": [
      "Modelagem",
      "Solicitações",
      "Automação"
    ]
  },
  {
    "id": "process-modeler",
    "title": "Modelagem de processos",
    "category": "Automação",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Studio → Processos → Novo/Editar processo",
    "order": 13,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Modele processos em BPMN, reutilize templates, configure propriedades de tarefas e publique versões prontas para execução.",
    "whenToUse": [
      "Criar um fluxo do zero ou ajustar etapas, eventos e gateways existentes.",
      "Gerar documentação em PDF ou salvar o desenho como modelo reutilizável."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Clique em “Editar” em um processo para abrir o Modelador e escolha um template pré-definido ou um fluxo em branco.",
      "Arraste tarefas, eventos e gateways para o canvas, conectando-os pelas setas de sequência conforme o desenho desejado.",
      "Selecione cada elemento para definir responsáveis, prazos, formulários associados e regras de transição no painel lateral.",
      "Use os botões superiores para validar o diagrama, salvar como rascunho, publicar ou gerar o PDF do processo para documentação."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Salve variações frequentes como modelos personalizados para acelerar a criação de novos fluxos.",
      "O botão “Imprimir PDF” gera um resumo visual do processo, útil para auditorias e treinamentos presenciais."
    ],
    "related": [
      "Processos",
      "Formulários",
      "Automação"
    ]
  },
  {
    "id": "process-runner",
    "title": "Execução guiada de processos",
    "category": "Operações",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Minhas solicitações → Abrir solicitação / execução da etapa",
    "order": 14,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Acompanhe execuções em tempo real, avance etapas manualmente quando necessário e visualize indicadores de progresso.",
    "whenToUse": [
      "Apoiar equipes com dificuldades em etapas específicas.",
      "Reprocessar etapas manuais após correções de dados ou anexos."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Processos → “Execução” para buscar a instância desejada pelo ID ou solicitante.",
      "Verifique a linha do tempo das etapas, com status e responsáveis destacados.",
      "Quando autorizado, utilize “Avançar manualmente” ou “Reabrir etapa” para ajustar o fluxo.",
      "Registre observações para documentar a intervenção e manter o histórico completo."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Intervenções manuais ficam registradas na auditoria; utilize-as com critério.",
      "Ative alertas de SLA para ser notificado antes de uma etapa vencer."
    ],
    "related": [
      "Solicitações",
      "Auditoria",
      "Automação"
    ]
  },
  {
    "id": "form-builder",
    "title": "Construtor de formulários",
    "category": "Automação",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Studio → Formulários → Novo/Editar formulário",
    "order": 16,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Construa formulários dinâmicos arrastando campos, configurando validações, regras condicionais e pré-visualizando o resultado em tempo real.",
    "whenToUse": [
      "Criar formulários reutilizáveis ou específicos para um processo.",
      "Aplicar máscaras, listas dinâmicas e lógica condicional sem escrever código."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra um formulário no modo de edição para acessar o construtor com painel de componentes à esquerda.",
      "Arraste campos de texto, números, anexos, seleções dinâmicas ou grupos para o layout e ajuste o tamanho de cada coluna.",
      "Defina rótulos, obrigatoriedade, máscaras, descrições e expressões condicionais na área de propriedades do campo.",
      "Utilize os botões superiores para salvar, salvar como rascunho ou abrir a prévia em uma nova aba antes de publicar."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Organize campos em grupos para controlar modos de edição e leitura por etapa do processo.",
      "Dê nomes únicos e padronizados aos campos para facilitar integrações e geração de relatórios."
    ],
    "related": [
      "Formulários",
      "Automação",
      "Processos"
    ]
  },
  {
    "id": "form-preview-external",
    "title": "Formulários externos e pré-visualização",
    "category": "Operações",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Studio → Formulários → Pré-visualizar/Link externo",
    "order": 17,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Disponibilize formulários para públicos externos com tokens seguros e valide a experiência em uma pré-visualização interativa.",
    "whenToUse": [
      "Abrir canais de atendimento para clientes, parceiros ou fornecedores sem acesso à plataforma.",
      "Testar o layout e as validações do formulário antes de publicá-lo."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Ative o link externo do formulário e copie o endereço diretamente do cartão no catálogo.",
      "Compartilhe o link público ou incorpore-o em portais internos utilizando o endereço iFrame exibido quando habilitado.",
      "Acesse “Prévia” no construtor para simular o preenchimento, validar regras condicionais e garantir responsividade.",
      "Quando necessário, gere um novo token para revogar acessos anteriores ou limitar o número de respostas aceitas."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Revise periodicamente quem está divulgando o link externo para garantir que somente a versão vigente seja utilizada.",
      "Use a pré-visualização para validar campos de upload e máscaras em dispositivos móveis antes da publicação."
    ],
    "related": [
      "Formulários",
      "Segurança",
      "Processos"
    ]
  },
  {
    "id": "automation-hub",
    "title": "Encontrar integrações e logs",
    "category": "Integrações",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Configurações → Integrações",
    "order": 18,
    "aliases": [
      "integrações",
      "integração",
      "automações",
      "hub",
      "logs de integração",
      "e-mail"
    ],
    "questions": [
      "Onde ficam as integrações?",
      "Onde ficam os logs de integração?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Abra Integrações para acessar Central, E-mail e Logs de Integração, de acordo com as permissões disponíveis.",
    "whenToUse": [],
    "prerequisites": [
      "Ter ao menos uma das permissões que permitem abrir Integrações."
    ],
    "steps": [
      "No Dashboard, expanda “Configurações”.",
      "Abra “Integrações”.",
      "Escolha “Central” para processos, APIs, RPA e conectores.",
      "Escolha “E-mail” para configuração de e-mail do sistema e marketing, se autorizado.",
      "Escolha “Logs de Integração” para falhas e inconsistências de sincronização, se autorizado."
    ],
    "rules": [
      "O nome atual do item do menu é “Integrações”.",
      "O menu pode ser aberto por permissões de automações, processos, e-mail ou logs; cada operação interna mantém seu controle de acesso."
    ],
    "expectedResult": "A seção de integração selecionada é apresentada conforme o acesso da conta.",
    "errors": [
      "Se uma seção não estiver disponível, solicite à administração a conferência da permissão correspondente."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "integration-settings",
    "title": "Configurações de integrações",
    "category": "Automação",
    "audience": "TI",
    "journeyStage": "Execução diária",
    "accessPath": "Studio → Processos → Integrações / Configurações de integração",
    "order": 19,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Configure webhooks e integrações por processo, ajuste cabeçalhos e eventos monitorados e exporte dados de solicitações para sistemas externos.",
    "whenToUse": [
      "Preparar um processo para enviar eventos ao CRM, ERP ou plataforma RPA.",
      "Atualizar credenciais, URLs ou status de integrações existentes."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra as Configurações de integração a partir do processo ou do Hub de Automação para listar webhooks cadastrados.",
      "Clique em “Nova integração” para informar nome, URL, método HTTP, tempo limite e eventos que devem disparar a requisição.",
      "Adicione cabeçalhos personalizados, ajuste o status ativo/inativo e salve a configuração para que o processo passe a enviar os dados.",
      "Utilize a seção “Exportação de dados” para gerar arquivos CSV com solicitações concluídas ou em andamento filtradas por período e status."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Guarde descrições claras sobre o sistema de destino em cada integração para facilitar auditorias futuras.",
      "Ao rotacionar credenciais, marque a opção de limpar senha/autenticação para garantir que nenhum dado antigo permaneça armazenado."
    ],
    "related": [
      "Automação",
      "Processos",
      "TI"
    ]
  },
  {
    "id": "agenda-collaboration",
    "title": "Agenda colaborativa",
    "category": "Operações",
    "audience": "Colaboradores",
    "journeyStage": "Execução diária",
    "accessPath": "Agenda",
    "order": 20,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Planeje atividades pessoais e de equipe, envie lembretes para usuários ou setores e sincronize calendários externos via iCal.",
    "whenToUse": [
      "Controlar prazos de aprovação, reuniões operacionais e eventos recorrentes ligados aos processos.",
      "Distribuir lembretes automáticos para toda a equipe diretamente da plataforma."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse a Agenda para visualizar o formulário de criação à esquerda e os painéis de eventos, aniversários e integrações à direita.",
      "Cadastre um novo evento informando título, data, observações e, se possuir permissão, selecione usuários, setores ou toda a base para envio automático.",
      "Use os botões de preferências para controlar se os próximos eventos aparecem no dashboard e ajuste lembretes individuais quando necessário.",
      "Conecte agendas externas preenchendo o link iCal/ICS e utilize os botões de sincronizar, atualizar ou remover integrações conforme o provedor."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Ativar a opção “Enviar para todos” dispara o lembrete individualmente para cada usuário cadastrado.",
      "Revise periodicamente as integrações conectadas e utilize o botão de sincronização manual para garantir que novos eventos sejam importados imediatamente."
    ],
    "related": [
      "Solicitações",
      "Processos",
      "Notificações"
    ]
  },
  {
    "id": "file-manager",
    "title": "Gestão de arquivos",
    "category": "Operações",
    "audience": "Colaboradores",
    "journeyStage": "Execução diária",
    "accessPath": "Arquivos",
    "order": 21,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Organize anexos provenientes dos processos, filtre por categoria, gerencie permissões e baixe arquivos diretamente do repositório central.",
    "whenToUse": [
      "Reunir documentos usados em formulários ou etapas específicas de processos.",
      "Controlar quem pode visualizar ou baixar evidências de auditoria."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Arquivos para navegar pela hierarquia categoria → formulário → campo utilizando os filtros de busca e categoria.",
      "Selecione uma pasta para abrir o visualizador, aplicar filtros por ano/mês, pesquisar pelo nome do arquivo e baixar evidências.",
      "Se possuir permissão, ajuste quem pode acessar cada pasta clicando em “Gerenciar acesso” e selecionando usuários ou setores autorizados.",
      "Use os botões de ação para baixar, excluir arquivos obsoletos ou remover categorias inteiras quando não forem mais necessárias."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "A pesquisa considera nomes de campos, formulários e categorias: combine termos para localizar anexos rapidamente.",
      "Verifique o resumo da pasta para identificar rapidamente o volume de arquivos por mês e ajustar filtros antes do download."
    ],
    "related": [
      "Solicitações",
      "Lixeira",
      "Auditoria"
    ]
  },
  {
    "id": "my-team",
    "title": "Minha equipe",
    "category": "Operações",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Minha equipe",
    "order": 22,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Visualize o desempenho da equipe, assuma ou libere tarefas do time e registre lembretes compartilhados.",
    "whenToUse": [
      "Identificar gargalos de solicitações sob responsabilidade da equipe.",
      "Criar lembretes coletivos para redistribuir prazos ou reuniões."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Configurações → Minha equipe para conferir os indicadores de solicitações em andamento, concluídas e atrasadas.",
      "Filtre por colaborador para visualizar apenas as tarefas atribuídas a um membro específico e use os botões “Assumir” ou “Liberar” conforme necessário.",
      "Abra o modal de evento para registrar compromissos compartilhados com o time, definindo título, data e notificação no dashboard.",
      "Consulte a lista de integrantes para verificar grupo, setor e quantidade de tarefas em curso antes de redistribuir demandas."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Utilize o filtro “Somente atrasos” (quando disponível) para atacar rapidamente os casos críticos da equipe.",
      "Anote decisões importantes no campo de descrição do evento da equipe para manter todos alinhados ao mesmo tempo."
    ],
    "related": [
      "Organograma",
      "Solicitações",
      "Agenda"
    ]
  },
  {
    "id": "organization-chart",
    "title": "Organograma",
    "category": "Operações",
    "audience": "Todos",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Organograma",
    "order": 23,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Explore a hierarquia corporativa, pesquise colaboradores e visualize a quantidade de subordinados diretamente no organograma interativo.",
    "whenToUse": [
      "Encontrar responsáveis antes de atribuir solicitações ou abrir chamados.",
      "Apresentar a estrutura da organização para novos colaboradores."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Configurações → Organograma para carregar o mapa hierárquico com zoom e rolagem horizontal.",
      "Utilize a busca para destacar colaboradores pelo nome, e-mail, grupo ou setor.",
      "Expanda ou recolha as ramificações utilizando as setas nos cartões para visualizar subordinados e contagens de equipe.",
      "Selecione um colaborador para consultar dados de contato, setor, grupo e relações diretas no painel lateral."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "A contagem exibida no cartão ajuda a identificar rapidamente lideranças com grandes equipes.",
      "Combine a busca com o filtro de colapso para focar apenas na unidade organizacional relevante."
    ],
    "related": [
      "Minha equipe",
      "Usuários",
      "Processos"
    ]
  },
  {
    "id": "audit-compliance",
    "title": "Auditoria do sistema",
    "category": "Administração",
    "audience": "Administradores",
    "journeyStage": "Administração",
    "accessPath": "Configurações → Auditoria",
    "order": 24,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Pesquise registros de auditoria por usuário, ação e período, visualize metadados e acompanhe paginação em tempo real.",
    "whenToUse": [
      "Rastrear quem realizou determinada ação em um processo ou configuração.",
      "Responder solicitações de compliance que exigem histórico de acessos."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Configurações → Auditoria e informe filtros de data, usuário (ID), tipo de ação e termos de busca antes de aplicar.",
      "Clique em “Aplicar filtros” para carregar os eventos na tabela paginada e navegue entre páginas usando os controles inferiores.",
      "Abra “Ver detalhes” na coluna de Metadados para inspecionar a carga completa enviada/recebida, incluindo duração da requisição."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O indicador de total encontrado ao lado do título ajuda a validar se a consulta retornou o volume esperado.",
      "Sempre limpe os filtros ao final de uma investigação para evitar conclusões com dados desatualizados em consultas futuras."
    ],
    "related": [
      "Usuários",
      "Processos",
      "Lixeira"
    ]
  },
  {
    "id": "trash-recovery",
    "title": "Lixeira e restauração",
    "category": "Administração",
    "audience": "Administradores",
    "journeyStage": "Administração",
    "accessPath": "Configurações → Lixeira",
    "order": 25,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Restaure ou remova definitivamente processos, formulários, solicitações e arquivos dentro do período de retenção.",
    "whenToUse": [
      "Reverter exclusões acidentais.",
      "Aplicar políticas de retenção, eliminando itens sensíveis em definitivo."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Em Configurações → Lixeira, escolha o tipo de item (processo, formulário, solicitação, arquivo ou categoria) para refinar a lista.",
      "Analise a tabela de itens excluídos verificando quem realizou a remoção, quando ocorreu e quanto tempo resta antes da exclusão definitiva.",
      "Use os botões “Restaurar” ou “Excluir definitivamente” conforme a ação desejada; o sistema solicitará confirmação em ambos os casos.",
      "Clique em “Atualizar” sempre que precisar recarregar a lista após recuperar ou remover itens."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O contador de expiração na coluna correspondente ajuda a priorizar quais itens precisam ser restaurados primeiro.",
      "Itens restaurados reaparecem no módulo de origem com as mesmas permissões e relacionamentos configurados anteriormente."
    ],
    "related": [
      "Arquivos",
      "Processos",
      "Auditoria"
    ]
  },
  {
    "id": "company-profile",
    "title": "Dados da empresa",
    "category": "Administração",
    "audience": "Administradores",
    "journeyStage": "Administração",
    "accessPath": "Meu Negócio → Dados Cadastrais",
    "order": 26,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Centralize dados institucionais, endereço, contatos e identidade visual exibidos nos formulários e comunicações.",
    "whenToUse": [
      "Atualizar nome fantasia, e-mail oficial ou logotipo utilizado na plataforma.",
      "Registrar observações institucionais para consultas internas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Configurações → “Empresa” para visualizar a ficha atual e os campos editáveis.",
      "Envie uma nova logo pelo botão “Enviar logo” e utilize “Remover logo” se preferir voltar para o estado padrão.",
      "Preencha informações de contato, endereço e notas e clique em “Salvar” para publicar as alterações."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Arquivos PNG ou SVG com fundo transparente rendem melhor no painel inicial e em formulários externos.",
      "Os campos são normalizados automaticamente para evitar espaços em branco desnecessários."
    ],
    "related": [
      "Formulários",
      "Processos",
      "Usuários"
    ]
  },
  {
    "id": "groups-management",
    "title": "Configurar Grupo/Permissões",
    "category": "Administração",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Configurações → Grupo/Permissões",
    "order": 27,
    "aliases": [
      "permissões",
      "permissão",
      "grupo",
      "grupos",
      "liberar acesso"
    ],
    "questions": [
      "Como criar um grupo?",
      "Como liberar permissões por módulo?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Organize o acesso por grupos e selecione permissões agrupadas por módulo.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso a Grupo/Permissões e autorização para a operação solicitada."
    ],
    "steps": [
      "Abra “Configurações → Grupo/Permissões”.",
      "Clique em “Novo grupo” ou abra a edição do grupo desejado.",
      "Informe o nome do grupo.",
      "Localize as permissões pelo módulo ou pela busca e marque as necessárias para as atividades da equipe.",
      "Confirme o formulário e confira o grupo na listagem."
    ],
    "rules": [
      "As permissões são organizadas por módulos e, na Gestão de Alunos, por seções de acesso e tarefas.",
      "A gestão de visibilidade de permissões é uma área específica do usuário master.",
      "Acesso ao menu não garante autorização para todas as operações internas do módulo."
    ],
    "expectedResult": "Grupo salvo com as permissões selecionadas e disponível para associação aos usuários.",
    "errors": [
      "Se a API rejeitar a operação, revise a mensagem exibida e a autorização da conta antes de tentar novamente."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "users-management",
    "title": "Cadastrar ou editar um usuário",
    "category": "Administração",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Configurações → Usuários",
    "order": 28,
    "aliases": [
      "usuário",
      "usuarios",
      "usuários",
      "novo usuário",
      "colaborador acesso",
      "superiores diretos"
    ],
    "questions": [
      "Como cadastrar um usuário?",
      "Como mudar o grupo do usuário?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Cadastre a conta e associe a pessoa ao grupo e setor corretos. A ficha também permite definir superiores diretos.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso a Usuários e autorização para cadastrar ou editar.",
      "Existirem um grupo e ao menos um setor para a associação."
    ],
    "steps": [
      "Abra “Configurações → Usuários” e clique em “Novo usuário”, ou abra a edição de uma conta.",
      "Preencha “Nome” e “E-mail”. Informe “Data de nascimento” e “CPF” quando aplicáveis.",
      "Selecione “Setor”; se necessário e autorizado, use “Gerenciar setores”.",
      "Na criação, defina “Senha”. Na edição, deixe esse campo em branco para manter a senha.",
      "Selecione “Grupo” e “Status”. Se houver hierarquia, selecione os “Superiores diretos”.",
      "Clique em “Criar usuário” ou “Salvar alterações”, conforme o formulário aberto."
    ],
    "rules": [
      "Nome, e-mail, setor, grupo e senha inicial são exigidos no formulário de criação.",
      "É possível selecionar mais de um superior direto.",
      "A senha em branco na edição mantém a senha existente.",
      "A área de identificação para assinaturas de outro usuário é apresentada ao master durante a edição."
    ],
    "expectedResult": "Conta criada ou alterações persistidas, com grupo, setor e status definidos.",
    "errors": [
      "“Selecione um setor para o usuário”: escolha um setor antes de enviar.",
      "“Cadastre ao menos um setor antes de criar usuários.”: use o gerenciamento de setores autorizado."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "mail-settings",
    "title": "Configurações de e-mail",
    "category": "Administração",
    "audience": "TI",
    "journeyStage": "Administração",
    "accessPath": "Configurações → E-mail",
    "order": 29,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Defina o servidor SMTP utilizado pelas notificações automáticas, atualize credenciais e envie e-mails de teste.",
    "whenToUse": [
      "Configurar o servidor de saída de e-mails corporativos.",
      "Atualizar senha ou parâmetros após a rotação de credenciais."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Configurações → E-mail para carregar o host, porta, remetente e usuário configurados atualmente.",
      "Atualize host, porta, nome do remetente, endereço de envio e usuário de autenticação; habilite TLS conforme exigência do provedor.",
      "Informe uma nova senha de autenticação quando necessário ou marque a opção de limpar senha para removê-la do armazenamento.",
      "Utilize o campo “Enviar e-mail de teste” para confirmar conectividade antes de salvar definitivamente as alterações."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O formulário indica quando há senha cadastrada; limpe-a antes de trocar o usuário para evitar inconsistências.",
      "Guarde o endereço de teste utilizado para validar envios e identificar rapidamente problemas de entrega."
    ],
    "related": [
      "Notificações",
      "Automação",
      "Usuários"
    ]
  },
  {
    "id": "dashboard-analytics",
    "title": "Painel analítico do dashboard",
    "category": "Início",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Dashboard",
    "order": 30,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Monitore tarefas, lembretes da agenda e indicadores avançados sem sair da tela inicial do dashboard.",
    "whenToUse": [
      "Iniciar o dia avaliando solicitações críticas e a carga atual da equipe.",
      "Abrir rapidamente Agenda, Process Runner ou outras abas a partir dos atalhos exibidos no painel."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Dashboard e utilize os botões “Operacional” e “Indicadores” para alternar entre os painéis disponíveis.",
      "Revise os cartões de tarefas (Tarefas, No prazo, Em alerta, Atrasado) e clique em um deles para filtrar a fila prioritária.",
      "Use o bloco “Ações recomendadas” para abrir solicitações críticas com o botão “Abrir solicitação” ou encaminhá-las ao Process Runner.",
      "Acompanhe os lembretes vindos da Agenda no painel lateral e clique em “Abrir” quando precisar tratar um compromisso imediatamente.",
      "Na aba de indicadores avançados, ajuste o campo “Dias” para atualizar gráficos como “Últimos movimentos” e “Novas solicitações (Xd)”."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Filtros aplicados aos cartões de tarefas permanecem ativos até que você volte para “Todas as tarefas”.",
      "Utilize o botão “Atualizar” presente no cabeçalho para recarregar contadores sempre que houver novas solicitações durante a sessão."
    ],
    "related": [
      "Agenda",
      "Solicitações",
      "Process Runner"
    ]
  },
  {
    "id": "finance-overview",
    "title": "Painel financeiro e resumo das contas",
    "category": "Financeiro",
    "audience": "Financeiro",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Financeiro",
    "order": 31,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Acompanhe saldos, movimentações e indicadores de conciliação por conta bancária em um único painel.",
    "whenToUse": [
      "Verificar rapidamente créditos, débitos e divergências antes do fechamento diário.",
      "Preparar relatórios financeiros com base no extrato mais recente ou validar importações automáticas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Financeiro para carregar a lista de contas bancárias cadastradas e os indicadores globais.",
      "Selecione uma conta para visualizar totais de créditos, débitos, saldo e contadores de conciliação.",
      "Utilize os botões “Resumo por categoria”, “Exportar relatório” e “Importar OFX” conforme a necessidade da análise.",
      "Clique em “Lançar transação manual” para registrar ajustes e em “Sincronizar conta” quando a integração estiver configurada como API.",
      "Acesse “Abrir gerenciador de categorias” para revisar o plano de contas antes de novos lançamentos ou conciliações."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Os cartões de status (Conciliadas, Pendentes, Divergentes) ajudam a priorizar quais lançamentos revisar primeiro.",
      "Importe ou sincronize os extratos antes de exportar relatórios para garantir que os valores reflitam o cenário atual."
    ],
    "related": [
      "Conciliação bancária",
      "Transações manuais",
      "Relatórios"
    ]
  },
  {
    "id": "finance-accounts",
    "title": "Cadastro de contas bancárias e integrações",
    "category": "Financeiro",
    "audience": "Financeiro",
    "journeyStage": "Administração",
    "accessPath": "Meu Negócio → Financeiro → Contas bancárias",
    "order": 32,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Cadastre contas, defina o tipo de integração e mantenha descrições e credenciais alinhadas ao fluxo financeiro.",
    "whenToUse": [
      "Habilitar uma nova conta para importação de extratos ou sincronização automática.",
      "Atualizar dados bancários, descrição interna ou remover contas que não serão mais conciliadas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "No módulo Financeiro, clique em “Nova conta bancária” para abrir o formulário de cadastro.",
      "Informe nome interno, banco, agência, conta e uma descrição que ajude a equipe a identificar o uso daquela conta.",
      "Selecione o tipo de integração (Lançamentos manuais, Importação via OFX ou Integração bancária automática) e preencha o campo de configuração JSON quando necessário.",
      "Salve para disponibilizar a conta; utilize as ações “Editar conta bancária” ou “Excluir” sempre que precisar ajustar dados já cadastrados.",
      "Após ativar uma integração do tipo API, utilize “Sincronizar conta” para validar credenciais e carregar os primeiros lançamentos."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Descreva no campo de observações como a conta é utilizada; isso facilita a identificação durante auditorias.",
      "Rotacione chaves de integração diretamente no JSON e aproveite o botão de sincronização para confirmar que novas credenciais estão válidas."
    ],
    "related": [
      "Painel financeiro e resumo das contas",
      "Conciliação bancária",
      "Transações manuais"
    ]
  },
  {
    "id": "finance-reconciliation",
    "title": "Conciliação bancária",
    "category": "Financeiro",
    "audience": "Financeiro",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Financeiro → Conciliação",
    "order": 33,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Filtre lançamentos, marque divergências e conclua conciliações com histórico documentado.",
    "whenToUse": [
      "Fechar o dia conciliando extratos importados com lançamentos internos.",
      "Registrar observações sobre diferenças encontradas e sinalizar itens pendentes para revisão."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Selecione a conta desejada e aplique filtros de status, período ou texto para reduzir a lista de transações.",
      "Marque manualmente as linhas ou utilize “Selecionar exibidas” para preparar o conjunto que será conciliado.",
      "Ative a opção “Marcar não selecionadas como divergentes” quando precisar sinalizar lançamentos que não batem com o extrato.",
      "Preencha “Observações da conciliação” com detalhes relevantes e finalize clicando em “Concluir conciliação”.",
      "Use as ações de cada transação para editar descrições, reclassificar categorias ou excluir lançamentos manuais quando necessário."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O resumo de seleção apresenta totais de créditos, débitos e quantidade para comparar rapidamente com o extrato bancário.",
      "Notas registradas durante a conciliação aparecem na auditoria e ajudam a rastrear ajustes futuros."
    ],
    "related": [
      "Painel financeiro e resumo das contas",
      "Transações manuais",
      "Auditoria"
    ]
  },
  {
    "id": "finance-manual-transactions",
    "title": "Transações manuais e categorias",
    "category": "Financeiro",
    "audience": "Financeiro",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Financeiro → Transações/Categorias",
    "order": 34,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Registre lançamentos pontuais, classifique receitas e despesas e mantenha o plano de contas alinhado ao relatório financeiro.",
    "whenToUse": [
      "Incluir ajustes que não vieram do extrato ou registrar despesas extraordinárias.",
      "Preparar categorias antes de gerar o resumo por centro de custo."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Com uma conta selecionada, clique em “Lançar transação manual” para abrir o formulário de lançamento.",
      "Defina se o movimento é Crédito ou Débito, informe valor, data de ocorrência e descrição detalhada.",
      "Associe categorias e subcategorias utilizando os seletores disponíveis; o formulário apresenta apenas subcategorias da categoria escolhida.",
      "Utilize o campo “Observações” para contextualizar o lançamento e clique em “Salvar transação” para aplicá-lo imediatamente.",
      "Sempre que precisar criar novas categorias ou revisar cores e limites, utilize o botão “Abrir gerenciador de categorias”."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Mensagens de validação aparecem acima do formulário quando houver campos obrigatórios em branco ou valores inválidos.",
      "Categorias e subcategorias definem os gráficos exibidos em “Resumo por categoria”; mantenha-as organizadas para relatórios mais ricos."
    ],
    "related": [
      "Conciliação bancária",
      "Painel financeiro e resumo das contas"
    ]
  },
  {
    "id": "asset-management-overview",
    "title": "Gestão do patrimônio corporativo",
    "category": "Patrimônio",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Patrimônio",
    "order": 35,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Controle ativos por categoria e localização, acompanhe depreciação e visualize manutenções pendentes em tempo real.",
    "whenToUse": [
      "Mapear o parque de ativos físicos antes de auditorias ou inventários.",
      "Identificar equipamentos com manutenção próxima ou valor contábil reduzido."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Patrimônio para consultar os cartões de indicadores e aplicar filtros por status, categoria ou localização.",
      "Utilize a tabela principal para conferir tag, série, custódia e valores de cada ativo.",
      "Acesse as ações “Manutenção”, “Editar” e “Excluir” para atualizar dados ou abrir intervenções específicas.",
      "Revise o quadro “Histórico recente” para acompanhar intervenções registradas e identificar responsáveis.",
      "Exporte a visão atual com o botão “Exportar CSV” sempre que precisar compartilhar o inventário completo."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Os selos de status (Em operação, Em manutenção, Em estoque, Baixado) ajudam a priorizar inspeções.",
      "Use filtros combinados de categoria e localização para localizar rapidamente ativos críticos durante auditorias."
    ],
    "related": [
      "Manutenções de ativos",
      "Inventário",
      "Relatórios"
    ]
  },
  {
    "id": "asset-maintenance",
    "title": "Manutenções de ativos",
    "category": "Patrimônio",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Patrimônio → Manutenções",
    "order": 36,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Registre manutenções preventivas, corretivas ou calibragens e acompanhe o ciclo até a conclusão.",
    "whenToUse": [
      "Programar intervenções obrigatórias ou registrar correções emergenciais.",
      "Atualizar status e custos após a execução do serviço de manutenção."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Selecione um ativo e clique em “Manutenção” para abrir o formulário dedicado.",
      "Escolha o tipo (Preventiva, Corretiva, Preditiva ou Calibração), defina status e informe datas planejadas ou realizadas.",
      "Registre responsável, custo estimado e notas detalhando a intervenção.",
      "Salve para adicionar o registro e utilize o botão “Concluir” no histórico quando a manutenção for finalizada.",
      "Exclua ou reprograme intervenções diretamente pelo histórico caso haja mudanças de escopo."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Manutenções abertas aparecem no resumo do ativo, facilitando a priorização de equipes técnicas.",
      "Registre custos sempre que possível para alimentar indicadores de depreciação e planejamento orçamentário."
    ],
    "related": [
      "Gestão do patrimônio corporativo",
      "Inventário",
      "Agenda"
    ]
  },
  {
    "id": "inventory-overview",
    "title": "Controle de estoque e produtos",
    "category": "Estoques",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Estoque",
    "order": 37,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Cadastre itens, monitore níveis de estoque e aplique filtros dinâmicos por depósito, categoria e status.",
    "whenToUse": [
      "Acompanhar itens críticos, rupturas ou excedentes antes de planejar compras.",
      "Exportar relatórios atualizados para fornecedores ou áreas de controladoria."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Controle de Estoque para visualizar indicadores iniciais como itens cadastrados, valor total e saídas do período.",
      "Utilize a pesquisa e os filtros por depósito, categoria, status e formato de relatório para refinar a visualização.",
      "Clique em “Novo item” para cadastrar produtos com SKU, unidades, limites mínimos/máximos e custos.",
      "Acompanhe a tabela principal para verificar validade, última movimentação e ações disponíveis (Movimentar, Editar, Excluir).",
      "Gere relatórios em PDF ou Excel com o botão “Exportar” após escolher o formato desejado."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "O destaque em amarelo sinaliza itens abaixo do mínimo definido; ajuste o filtro de status para focar nesses casos.",
      "Utilize o botão “Atualizar” sempre que novos lançamentos forem registrados por integrações externas."
    ],
    "related": [
      "Movimentações de estoque",
      "Inventário",
      "Relatórios"
    ]
  },
  {
    "id": "inventory-movements",
    "title": "Movimentações de estoque",
    "category": "Estoques",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Estoque → Movimentações",
    "order": 38,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Registre entradas, saídas e transferências com rastreabilidade por depósito e referência operacional.",
    "whenToUse": [
      "Atualizar estoque após recebimento, faturamento ou transferência entre unidades.",
      "Investigar movimentações recentes e validar responsáveis ou códigos de referência."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Localize o item desejado e clique em “Movimentar” para abrir o formulário de registro.",
      "Escolha o tipo (Entrada, Saída ou Transferência), informe quantidades, depósitos de origem/destino e referência.",
      "Defina o custo unitário quando necessário e ajuste a data/hora em “Ocorreu em” para refletir o momento real do movimento.",
      "Salve para atualizar imediatamente os saldos e consulte a seção “Movimentações recentes” para validar o registro.",
      "Use os filtros por tipo, depósito e período para localizar operações específicas durante auditorias."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "As quantidades exibidas em verde representam entradas; valores em vermelho identificam saídas e facilitam a análise visual.",
      "Preencha o código de referência para conectar o movimento ao pedido, NF ou solicitação correspondente."
    ],
    "related": [
      "Controle de estoque e produtos",
      "Solicitações",
      "Auditoria"
    ]
  },
  {
    "id": "registration-center-overview",
    "title": "Central de Cadastros",
    "category": "Cadastros",
    "audience": "Administradores",
    "journeyStage": "Execução diária",
    "accessPath": "Central de Cadastros",
    "order": 39,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Consulte os registros em largura total e adicione o cadastro ao menu para acessar suas fichas.",
    "whenToUse": [
      "Consultar formulários enviados sem precisar abrir a solicitação completa.",
      "Atualizar informações após o encerramento do processo mantendo trilha de auditoria."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse a Central de Cadastros e use “Escolha o cadastro”.",
      "Use os filtros da “Consulta de cadastros” para encontrar os registros.",
      "Clique em “Adicionar ao menu” para criar o acesso do cadastro; a página será aberta e ficará disponível no menu.",
      "Se o acesso já existir, clique em “Abrir cadastro” ou escolha seu nome no menu.",
      "Na página do cadastro, selecione uma linha para acessar detalhes, histórico, dashboard e campos adicionais; edite e salve conforme as permissões.",
      "Use “Recarregar” na ficha para consultar os dados novamente."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Solicitações em andamento podem ter campos bloqueados; finalize o processo ou utilize páginas dedicadas para liberar a edição.",
      "Na página do cadastro, confira solicitante, status e início antes de editar a ficha."
    ],
    "related": [
      "Personalização de relatórios",
      "Formulários",
      "Solicitações"
    ]
  },
  {
    "id": "registration-center-exports",
    "title": "Personalização de relatórios na Central",
    "category": "Cadastros",
    "audience": "Administradores",
    "journeyStage": "Administração",
    "accessPath": "Central de Cadastros → Relatórios/Exportações",
    "order": 40,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Configure colunas, gere relatórios em diferentes formatos e organize páginas dedicadas para cada processo.",
    "whenToUse": [
      "Montar planilhas específicas para auditoria, compliance ou integrações pontuais.",
      "Criar páginas dedicadas para equipes que precisam acessar um subconjunto de cadastros."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Clique em “Colunas e relatórios” para escolher quais campos aparecem no quadro de consultas.",
      "Utilize “Gerenciar campos extras” para adicionar dados derivados (IDs, status, solicitante, vínculos).",
      "Clique em “Exportar Excel” para gerar relatórios utilizando os filtros atualmente ativos.",
      "Use “Adicionar ao menu” para criar e abrir a página do cadastro. Se ela já existir, use “Abrir cadastro”.",
      "Na página do cadastro, use “Remover página” para retirar o acesso do menu; os registros permanecem disponíveis na consulta da Central."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "A tarja inferior do modal de exportação apresenta quantos registros serão incluídos conforme os filtros aplicados.",
      "Ao criar páginas dedicadas, utilize ícones e cores padronizados para facilitar a navegação dos usuários finais."
    ],
    "related": [
      "Central de Cadastros",
      "Formulários",
      "Relatórios"
    ]
  },
  {
    "id": "human-resources-overview",
    "title": "Visão geral de Recursos Humanos",
    "category": "Pessoas",
    "audience": "Gestores",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → Recursos Humanos",
    "order": 41,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Acompanhe indicadores de headcount, férias, aniversários e acesso ao sistema no painel de Recursos Humanos.",
    "whenToUse": [
      "Conferir rapidamente o quadro de colaboradores por departamento, vínculo e status.",
      "Preparar reuniões de acompanhamento de pessoas com dados consolidados em um único lugar."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Recursos Humanos para carregar os cartões de resumo com totais de colaboradores ativos, férias, licenças e acessos.",
      "Ajuste os filtros de busca, status, departamento ou tipo de vínculo para refinar a tabela principal e os gráficos.",
      "Analise os painéis de distribuição por departamento, vínculo e as listas de admissões recentes, aniversariantes e colaboradores sem acesso.",
      "Consulte a seção “Férias ou licença” para visualizar delegados definidos, datas de retorno e observações cadastradas."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Utilize o botão “Atualizar” sempre que concluir cadastros ou importações para sincronizar indicadores e listagens.",
      "Observe os selos de status coloridos na tabela para identificar rapidamente quem está em férias, licença ou desligamento."
    ],
    "related": [
      "Minha equipe",
      "Organograma",
      "Gestão de usuários"
    ]
  },
  {
    "id": "human-resources-records",
    "title": "Cadastro completo de colaboradores",
    "category": "Pessoas",
    "audience": "Administradores",
    "journeyStage": "Administração",
    "accessPath": "Meu Negócio → Recursos Humanos → Cadastrar/Editar colaborador",
    "order": 42,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Cadastre, edite e gerencie colaboradores incluindo dados pessoais, contratuais, endereços e acesso ao sistema.",
    "whenToUse": [
      "Realizar onboarding de novos colaboradores ou atualizar cadastros existentes.",
      "Registrar férias, licenças, delegados e vínculos com usuários da plataforma."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Clique em “Cadastrar colaborador” para abrir o formulário completo com dados pessoais, contratuais e endereço profissional.",
      "Associe o cadastro a um usuário do sistema quando precisar conceder acesso; os campos principais são preenchidos automaticamente conforme o usuário selecionado.",
      "Defina status (Ativo, Férias, Licença, Inativo ou Desligado), configure delegados e informe datas de admissão ou término conforme necessário.",
      "Salve para criar ou atualizar o registro e utilize as ações da tabela para editar novamente ou excluir colaboradores obsoletos.",
      "Anote observações relevantes no campo de notas para manter o histórico centralizado no próprio cadastro."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Somente usuários com permissão de gestão de RH visualizam o botão de cadastro e as ações de edição ou exclusão.",
      "Preencha matrícula e tipo de vínculo para facilitar integrações com folha de pagamento ou relatórios financeiros."
    ],
    "related": [
      "Visão geral de Recursos Humanos",
      "Gestão de usuários",
      "Agenda colaborativa"
    ]
  },
  {
    "id": "human-resources-reports",
    "title": "Relatórios e exportações de RH",
    "category": "Pessoas",
    "audience": "Gestores",
    "journeyStage": "Administração",
    "accessPath": "Meu Negócio → Recursos Humanos → Relatórios",
    "order": 43,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Gere relatórios em CSV ou PDF com filtros personalizados e utilize modelos prontos no painel de relatórios avançados.",
    "whenToUse": [
      "Compartilhar dados com contabilidade, folha ou comitês de pessoas.",
      "Registrar evidências para auditorias trabalhistas ou revisões internas de compliance."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Aplique filtros de status, departamento, vínculo ou busca livre para preparar o recorte desejado na lista de colaboradores.",
      "Utilize os botões “Exportar CSV” ou “Exportar PDF” para gerar arquivos com os dados filtrados da visão atual.",
      "Abra “Relatórios avançados” para acessar modelos prontos, como colaboradores sem acesso, por status ou por departamento.",
      "No modal, escolha o relatório e confirme o download; mensagens de erro aparecem no próprio painel quando houver inconsistências.",
      "Armazene os arquivos gerados conforme a política interna e registre o envio em seu controle de compliance, quando aplicável."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Durante a geração de arquivos, aguarde o término indicado no botão antes de solicitar um novo download.",
      "Combine filtros por status e departamento para gerar planilhas específicas, como férias programadas por equipe."
    ],
    "related": [
      "Visão geral de Recursos Humanos",
      "Personalização de relatórios na Central",
      "Auditoria do sistema"
    ]
  },
  {
    "id": "crm-pipeline",
    "title": "CRM e oportunidades comerciais",
    "category": "Vendas",
    "audience": "Comercial",
    "journeyStage": "Execução diária",
    "accessPath": "Meu Negócio → CRM",
    "attention": "O CRM fica dentro de Meu Negócio e depende das permissões de visualização do módulo; mantenha etapa e próximo passo atualizados para que os indicadores façam sentido.",
    "order": 44,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Gerencie oportunidades por empresa, segmento, responsável, valor, etapa do funil, próximo passo, data prevista e observações.",
    "whenToUse": [
      "Acompanhar prospecções, propostas, negociações e oportunidades ganhas ou perdidas.",
      "Priorizar contatos comerciais por valor, estágio, responsável e próxima ação planejada."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Meu Negócio → CRM para revisar o funil e os indicadores de oportunidades.",
      "Cadastre uma oportunidade informando nome, empresa, segmento, responsável, valor estimado, etapa, ciclo, próximo passo e data do próximo contato.",
      "Atualize a etapa conforme o avanço da negociação para manter previsões e relatórios coerentes.",
      "Use filtros e busca para localizar oportunidades por cliente, responsável, status ou período.",
      "Registre observações relevantes após reuniões, ligações e propostas para preservar o histórico da negociação."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Mantenha sempre o próximo passo preenchido; oportunidades sem ação definida tendem a ficar paradas no funil.",
      "Revise valores e etapas antes de reuniões de forecast para evitar indicadores comerciais distorcidos."
    ],
    "related": [
      "Dados da empresa",
      "Agenda colaborativa",
      "Painel analítico do dashboard"
    ]
  },
  {
    "id": "courses-learning",
    "title": "Encontrar cursos e trilhas de ensino",
    "category": "Cursos",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Cursos",
    "order": 45,
    "aliases": [
      "cursos",
      "curso",
      "catálogo do aluno",
      "cursos matriculados",
      "trilhas de ensino",
      "matricular"
    ],
    "questions": [
      "Onde ficam meus cursos matriculados?",
      "Como encontrar uma trilha de ensino?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Encontre os cursos pelo Catálogo do aluno, acompanhe os Cursos Matriculados e consulte Trilhas de Ensino.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso a Cursos e às ofertas disponibilizadas para sua conta."
    ],
    "steps": [
      "Abra “Cursos”.",
      "Escolha “Catálogo do aluno” para localizar uma oferta.",
      "Abra o curso desejado e confira as informações e ações disponíveis.",
      "Use “Matricular” quando a oferta permitir matrícula e a ação estiver disponível.",
      "Abra “Cursos Matriculados” para continuar os cursos em que já está inscrito.",
      "Consulte “Trilhas de Ensino” para as jornadas disponibilizadas."
    ],
    "rules": [
      "Os rótulos atuais são “Catálogo do aluno”, “Cursos Matriculados” e “Trilhas de Ensino”.",
      "“Editor de cursos” e “Turmas e acessos” são áreas condicionadas às permissões administrativas.",
      "A disponibilidade da matrícula depende das ações liberadas para a oferta e para a conta.",
      "Não presuma que todo curso permita matrícula, emissão de certificado ou acesso imediato."
    ],
    "expectedResult": "Curso ou trilha localizado, com acesso às ações permitidas à conta.",
    "errors": [
      "“Nenhum curso encontrado”: revise a busca e os filtros.",
      "Se uma ação administrativa não aparecer, confira a permissão correspondente."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "courses-management",
    "title": "Administração de cursos e turmas",
    "category": "Cursos",
    "audience": "Instrutores e administradores",
    "journeyStage": "Administração",
    "accessPath": "Cursos → Área administrativa",
    "attention": "As opções administrativas aparecem apenas para usuários com permissão de criação/gestão de cursos ou perfil equivalente.",
    "order": 46,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Crie cursos, aulas, materiais, certificados, turmas, matrículas, concessões e avalie atividades enviadas pelos alunos.",
    "whenToUse": [
      "Publicar capacitações internas com materiais, atividades e certificados padronizados.",
      "Gerenciar turmas, liberar acessos e acompanhar entregas dos participantes."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Use a área de edição para criar ou atualizar cursos com título, descrição, instrutor, categoria, duração, status, cor e imagem.",
      "Organize módulos e aulas, anexando vídeos, links, arquivos e atividades avaliativas conforme a metodologia do curso.",
      "Configure certificado, pré-requisitos e trilhas quando o curso fizer parte de uma jornada maior de aprendizagem.",
      "Crie turmas com curso, responsáveis, alunos, datas e capacidade; use concessões para liberar cursos a usuários específicos.",
      "Acompanhe envios de atividades na área de avaliação, filtre por aluno, curso ou turma e registre feedback quando aplicável."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Revise a soma automática da duração das aulas para que a carga horária do certificado fique coerente.",
      "Publique somente cursos revisados; mantenha rascunhos enquanto materiais e atividades ainda estiverem incompletos."
    ],
    "related": [
      "Cursos e trilhas de aprendizagem",
      "Gestão de usuários",
      "Gestão de Alunos"
    ]
  },
  {
    "id": "courses-ai-complete",
    "title": "Gerar curso completo com a Nash IA",
    "category": "Cursos",
    "audience": "Instrutores e administradores",
    "journeyStage": "Administração",
    "accessPath": "Cursos → Editor de cursos → Nash IA",
    "order": 47,
    "aliases": [
      "gerar curso com IA",
      "curso completo",
      "apostila automática",
      "continuar geração",
      "somente estrutura"
    ],
    "questions": [
      "Como gerar aulas, apostilas e avaliações com a Nash IA?",
      "Como continuar a geração de um curso após uma falha?",
      "A Nash IA salva ou publica o curso automaticamente?",
      "As fontes da apostila são verificadas?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Prepare uma prévia de curso com módulos, aulas, apostilas, atividades e avaliações; revise antes de aplicar ao rascunho e salvar.",
    "whenToUse": [
      "Criar conteúdo didático a partir de um pedido para a Nash IA no Editor de cursos.",
      "Retomar aulas pendentes depois de uma falha durante a elaboração completa."
    ],
    "prerequisites": [
      "Ter acesso ao Editor de cursos e à criação: a interface exibe a autoria para administrador ou conta com CRIADOR_DE_CONTEUDO. A autorização das operações de IA no backend aceita CRIADOR_DE_CONTEUDO, GERENCIAR_CURSOS ou PROFESSOR, além do tratamento administrativo da autorização.",
      "Ter a Nash IA configurada com chave e modelo disponíveis. A geração depende da resposta do provedor.",
      "Resolver uma eventual recuperação de rascunho pendente; a autoria fica desabilitada durante essa recuperação e enquanto o curso está sendo salvo."
    ],
    "steps": [
      "Em “Cursos”, abra “Editor de cursos” e prepare um curso novo ou abra o curso que deseja editar.",
      "Em “Pedido para a Nash IA”, descreva tema, público, objetivos, nível e carga horária desejada, com até 6.000 caracteres.",
      "Mantenha “Curso completo” e “Somente estrutura” desmarcado em “Mais opções da Nash IA” para elaborar aulas, apostilas e avaliações; clique em “Gerar prévia do curso”.",
      "Acompanhe o planejamento inicial e depois o progresso “Aula 1/…”: cada aula é elaborada em sequência. Aguarde todas as aulas para receber a prévia aplicável.",
      "Se uma aula falhar, use “Continuar geração” para retomar a aula pendente, preservando as aulas já concluídas nesta geração. Use “Descartar geração” para abandonar o trabalho parcial.",
      "Em “Confira a sugestão antes de aplicar”, revise os valores atuais e sugeridos. Clique em “Aplicar ao rascunho” ou “Descartar prévia”.",
      "Em “2. Conteúdo”, revise cada “Apostila da aula · editar e visualizar”, suas fontes, atividades, alternativas, gabaritos e “Explicação do gabarito”. Ajuste o conteúdo quando necessário.",
      "Revise os dados institucionais e o certificado, preencha o nome de quem assina e use “Salvar curso” ou “Salvar alterações”. A publicação continua sendo uma ação separada."
    ],
    "rules": [
      "O fluxo completo primeiro solicita o planejamento e depois elabora as aulas, uma por vez. O planejamento isolado não é aplicado nem salvo durante essa sequência.",
      "A elaboração completa exige apostila com pelo menos 3.000 caracteres e referências válidas, ao menos uma atividade com três questões e avaliação com pelo menos cinco questões. As questões geradas são de múltipla escolha, com exatamente quatro alternativas, gabarito válido, pontuação positiva e explicação.",
      "A Nash solicita pesquisa web para cada aula completa; quando a integração oferece essa ferramenta, a requisição exige seu uso. Se a integração recorrer à alternativa sem pesquisa, as referências ficam sugeridas, sem alegação de verificação.",
      "“Verificada na pesquisa” indica uma URL correspondente às evidências retornadas pela ferramenta de pesquisa efetivamente utilizada; não significa aprovação pedagógica ou garantia de exatidão de todo o conteúdo. “Sugerida — não verificada” exige conferência do professor.",
      "“Mais opções da Nash IA” contém “Somente estrutura”, “Parte do curso para alterar” e “Gerar prévia da capa”. A opção “Somente estrutura” e a escolha de uma parte específica evitam a sequência de elaboração completa por aula.",
      "Ao reelaborar aulas já salvas, o planejamento retém atividades e avaliações como contexto; a elaboração mantém as identidades correspondentes e os arquivos existentes das aulas. Revise alterações de conteúdo antes de salvar.",
      "A geração de imagens é limitada à capa; a elaboração das aulas não gera vídeos, anexos ou imagens didáticas.",
      "“Cancelar geração” descarta o trabalho parcial exibido. Alterar o pedido, as opções, o rascunho ou o curso também invalida a geração ou prévia anterior. A continuação depende de manter esse estado na tela; não há promessa de retomada após recarregar ou sair.",
      "“Aplicar ao rascunho” altera o formulário. “Desfazer aplicação da IA” restaura o estado anterior enquanto a aplicação ainda corresponde ao rascunho atual. Gerar ou aplicar não salva nem publica o curso.",
      "A apostila pode ser editada e exportada em HTML; “Imprimir / salvar PDF” abre uma versão para impressão, e o PDF depende da opção de salvar do navegador.",
      "Referências aceitam URLs HTTPS públicas sem credenciais; URLs rejeitadas não são incluídas ao salvar. Alterar a URL de uma referência no editor marca essa referência como sugerida."
    ],
    "expectedResult": "Prévia completa conferida pelo responsável, aplicada ao formulário e disponível para revisão e salvamento manual do curso.",
    "errors": [
      "“Escreva um prompt de até 6.000 caracteres.”: preencha um pedido e reduza seu tamanho.",
      "“A Nash IA não concluiu os materiais e atividades desta aula. Tente continuar a geração.”: use “Continuar geração” para tentar novamente a aula pendente.",
      "“A aula não retornou referências válidas. Tente continuar a geração.”: retome a geração e confira as referências antes de salvar.",
      "“As alternativas geradas precisam ser distintas. Tente continuar a geração.”: retome a aula para gerar alternativas diferentes.",
      "“Aguarde um minuto antes de solicitar novamente à Nash IA.”: aguarde o intervalo indicado e continue; o limite de solicitações também pode atingir uma sequência com muitas aulas.",
      "“Não foi possível gerar a sugestão da Nash IA. Tente novamente.”: tente novamente; se o trabalho parcial ainda estiver disponível, use “Continuar geração”.",
      "“Informe o nome de quem assina o certificado na edição do curso.”: preencha o assinante antes de salvar."
    ],
    "tips": [
      "Faça a revisão pedagógica das apostilas e confira se as questões cobram o conteúdo ensinado.",
      "Use “Adicionar fonte sugerida” para registrar uma referência adicional que você ainda vai conferir."
    ],
    "related": [
      "Encontrar cursos e trilhas de ensino",
      "Consultar e baixar apostilas das aulas",
      "Administração de cursos e turmas"
    ]
  },
  {
    "id": "project-bank-overview",
    "title": "Banco de Projetos",
    "category": "Projetos",
    "audience": "Gestores",
    "journeyStage": "Planejamento e transparência",
    "accessPath": "Banco de Projetos",
    "order": 47,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Cadastre projetos institucionais, acompanhe status, orçamento, etapas, anexos, indicadores e links públicos de transparência em um único módulo.",
    "whenToUse": [
      "Consolidar propostas, projetos aprovados e iniciativas em execução em uma visão de portfólio.",
      "Controlar prazos, percentuais de avanço, fontes de recurso, despesas e evidências para prestação de contas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Banco de Projetos no menu lateral e revise o dashboard com totais, projetos atrasados, concluídos, arquivados e indicadores financeiros.",
      "Use filtros de busca, status, atraso, conclusão e arquivamento para localizar rapidamente a iniciativa desejada.",
      "Clique em “Novo projeto” ou abra um projeto existente para preencher dados gerais, apresentação, justificativa, público-alvo, local, área/eixo e responsáveis.",
      "Atualize status e progresso conforme a execução avança; projetos podem passar por rascunho, planejado, em execução, pausado, atrasado, concluído ou cancelado.",
      "Registre fontes de recurso, orçamento, despesas previstas e realizadas para que os totais de aprovado, recebido, executado e saldo sejam calculados no acompanhamento.",
      "Cadastre etapas com responsável, datas, status e percentual de conclusão; use a ação de concluir etapa para marcar 100% e registrar a data real de término.",
      "Inclua acompanhamentos e anexos por categoria para manter evidências, atas, imagens, contratos e demais documentos vinculados ao projeto.",
      "Quando precisar compartilhar resultados, gere PDF ou publique o link de transparência com as seções e arquivos liberados para consulta externa."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Mantenha capa, logo e textos institucionais padronizados nas configurações para que PDFs e páginas públicas tenham identidade visual consistente.",
      "Use o recurso “Escrever com IA” para apoiar textos de apresentação, objetivos e justificativas, revisando o conteúdo antes de salvar.",
      "Arquive projetos encerrados que não devem aparecer no acompanhamento diário, preservando histórico e evidências para auditoria."
    ],
    "related": [
      "Painel analítico do dashboard",
      "Gestão de arquivos",
      "Auditoria do sistema"
    ]
  },
  {
    "id": "courses-study-material",
    "title": "Consultar e baixar apostilas das aulas",
    "category": "Cursos",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Cursos → Cursos Matriculados",
    "order": 48,
    "aliases": [
      "baixar apostila",
      "material da aula",
      "apostila PDF",
      "fontes da apostila",
      "gabarito explicado"
    ],
    "questions": [
      "Como baixar a apostila de uma aula?",
      "Como salvar a apostila em PDF?",
      "Onde aparece a explicação do gabarito?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Consulte a apostila disponibilizada na aula, suas referências e as opções de baixar HTML ou imprimir e salvar em PDF.",
    "whenToUse": [
      "Estudar o texto de uma aula e consultar as fontes indicadas.",
      "Baixar uma cópia da apostila disponível."
    ],
    "prerequisites": [
      "Conseguir abrir o curso e a aula com a sua conta.",
      "A aula precisa ter texto de apostila; as opções de exportação aparecem somente quando esse conteúdo está disponível."
    ],
    "steps": [
      "Abra o curso em “Cursos Matriculados” e selecione a aula disponível.",
      "Em “Conteúdo da aula”, leia a apostila e confira “Fontes e referências”, quando houver.",
      "Clique em “Baixar apostila (HTML)” para baixar o texto e suas referências em arquivo HTML.",
      "Para PDF, clique em “Imprimir / salvar PDF”; na versão aberta, use o botão de mesmo nome e escolha a opção de salvar em PDF do navegador, se disponível.",
      "Depois de enviar uma atividade ou avaliação, consulte a explicação e a resposta correta das questões de múltipla escolha, quando o curso tiver esse conteúdo e o envio estiver registrado na tela."
    ],
    "rules": [
      "A apostila aparece dentro da aula, junto aos materiais complementares que o professor tenha anexado.",
      "“Conclua a aula anterior para visualizar o conteúdo desta aula.” indica que o conteúdo ainda está bloqueado pela sequência apresentada ao aluno.",
      "“Verificada na pesquisa” indica que a pesquisa consultou a fonte correspondente; “Sugerida — não verificada” identifica referências que precisam de conferência pelo professor.",
      "A exportação em HTML inclui texto e referências da apostila. A opção de PDF utiliza a impressão do navegador.",
      "A explicação do gabarito aparece apenas quando existe explicação cadastrada e a tela reconhece um envio da atividade ou tentativa da avaliação correspondente."
    ],
    "expectedResult": "Apostila lida na aula ou exportada, com o estado de verificação das referências visível.",
    "errors": [
      "“Conclua a aula anterior para visualizar o conteúdo desta aula.”: conclua a aula anterior e volte ao conteúdo.",
      "Se os botões da apostila não aparecerem, confira se a aula contém texto de apostila; anexos complementares são exibidos separadamente."
    ],
    "tips": [
      "Confira a indicação de verificação antes de usar uma referência em outro trabalho."
    ],
    "related": [
      "Encontrar cursos e trilhas de ensino",
      "Gerar curso completo com a Nash IA"
    ]
  },
  {
    "id": "project-bank-transparency-settings",
    "title": "Configurações, PDFs e transparência de projetos",
    "category": "Projetos",
    "audience": "Administradores",
    "journeyStage": "Planejamento e transparência",
    "accessPath": "Banco de Projetos → Configurações/Projeto → PDF e Transparência",
    "attention": "Antes de liberar transparência pública, revise dados sensíveis e anexos: arquivos expostos no link poderão ser consultados fora da área autenticada.",
    "order": 48,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Configure identidade visual, campos exibidos, integração com IA, gráficos, geração de PDF e publicação de links públicos do Banco de Projetos.",
    "whenToUse": [
      "Preparar modelos padronizados para propostas, relatórios executivos e páginas públicas de prestação de contas.",
      "Definir quais informações, tabelas, imagens e anexos ficarão disponíveis para consulta externa."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra as configurações do Banco de Projetos para revisar logo, textos padrão, rodapé, alinhamento, cores e imagens usadas nos documentos.",
      "Configure colunas de tabelas públicas, categorias de arquivos e opções de transparência conforme a política de comunicação da organização.",
      "Em Integração com IA, cadastre os parâmetros necessários para habilitar sugestões de texto no formulário de projeto.",
      "No projeto, use a área de gráficos para salvar configurações e visualizar dados consolidados de orçamento, despesas, status e andamento.",
      "Gere PDFs a partir do projeto, confira a lista de versões criadas e baixe o arquivo desejado quando precisar enviar relatórios.",
      "Ative ou copie o link de transparência quando o projeto estiver pronto para publicação; a página externa mostra dados, objetivos, orçamento, etapas e arquivos permitidos."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Revise anexos e campos sensíveis antes de liberar uma página pública, pois arquivos categorizados para transparência poderão ser baixados pelo link.",
      "Padronize nomes de categorias para facilitar a navegação pública e a prestação de contas por tipo de documento."
    ],
    "related": [
      "Banco de Projetos",
      "Configurações de integrações",
      "Dados da empresa"
    ]
  },
  {
    "id": "student-management-overview",
    "title": "Gestão de Alunos",
    "category": "Alunos",
    "audience": "Equipe pedagógica",
    "journeyStage": "Execução diária",
    "accessPath": "Gestão de Alunos",
    "attention": "Alguns dados de aluno são confidenciais e podem exigir permissão específica; se uma informação não aparecer, confirme seu perfil de acesso com o administrador.",
    "order": 49,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Gerencie cursos, turmas, alunos, frequência, intercorrências, histórico, relatórios e configurações acadêmicas em um fluxo único.",
    "whenToUse": [
      "Acompanhar matrículas, status, dados sociais e informações de contato dos alunos.",
      "Registrar frequência, faltas, ocorrências e movimentações para apoiar decisões pedagógicas e administrativas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse Gestão de Alunos e revise o dashboard com indicadores de alunos ativos, inativos, inscrições, turmas, cursos e gráficos habilitados nas configurações.",
      "Cadastre grupos com nome, descrição e informações complementares; depois crie turmas vinculando grupo, responsável, período, horários, capacidade e status.",
      "Abra o cadastro de aluno para preencher matrícula, nome, CPF, data de nascimento, gênero, contatos, endereço, escola, CRAS, dados familiares e campos personalizados.",
      "Vincule o aluno à turma correta e mantenha o status atualizado como ativo ou inativo, preenchendo data e motivo de saída quando houver baixa.",
      "Registre frequências por data, turma e aluno; acompanhe faltas para identificar casos que atingem os critérios de baixa frequência.",
      "Lance intercorrências com descrição, data, aluno e responsável para manter histórico pedagógico e social centralizado.",
      "Use o histórico do aluno para consultar alterações relevantes, frequência, eventos e mudanças realizadas por usuários autorizados."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Valide CPF, matrícula e nome antes de salvar para evitar registros duplicados; o sistema alerta quando identifica dados únicos já cadastrados.",
      "Mantenha WhatsApp e e-mail atualizados para facilitar comunicações de ausência, retorno e acompanhamento familiar.",
      "Dados confidenciais dependem de permissão específica; conceda acesso apenas a perfis que realmente precisam consultar essas informações."
    ],
    "related": [
      "Gestão de usuários",
      "Auditoria do sistema"
    ]
  },
  {
    "id": "student-management-reports-settings",
    "title": "Relatórios e configurações da Gestão de Alunos",
    "category": "Alunos",
    "audience": "Gestores",
    "journeyStage": "Administração",
    "accessPath": "Gestão de Alunos → Configurações / Aba de Consulta",
    "attention": "Configurações alteram comportamento operacional do módulo; revise baixa frequência, colunas e listas com a coordenação antes de salvar mudanças amplas.",
    "order": 50,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Personalize baixa frequência, mensagens, gráficos, opções de cadastro, colunas de consulta, abas extras e exportações em PDF ou Excel.",
    "whenToUse": [
      "Ajustar regras operacionais de acompanhamento de faltas, motivos de saída, escolas e CRAS de referência.",
      "Gerar consultas e relatórios com colunas específicas para coordenação, parceiros ou prestação de contas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Configurações dentro da Gestão de Alunos e defina se a baixa frequência ficará ativa e após quantas faltas o aluno deve ser inativado automaticamente.",
      "Personalize a mensagem de WhatsApp usando variáveis como {aluno}, {faltas} e {dias}, e cadastre e-mails que receberão notificações de baixa frequência.",
      "Escolha os widgets exibidos no dashboard, como ativos x inativos, inscrições, gênero, idade, turma, grupo, CRAS, escola e motivos de saída.",
      "Mantenha listas de CRAS, escolas e motivos de saída; use renomeações quando precisar padronizar dados já existentes.",
      "Configure as colunas padrão da Aba de Consulta e, quando necessário, crie abas extras com campos de texto, texto longo, checkbox ou combobox.",
      "Na Aba de Consulta, aplique busca rápida e filtros avançados por nome, CPF, WhatsApp, e-mail, datas, status, motivo de saída e turma.",
      "Antes de exportar PDF ou Excel, selecione as colunas desejadas; acima de sete colunas, o relatório organiza cada aluno em blocos para preservar a leitura."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Revise periodicamente listas de escolas, CRAS e motivos de saída para evitar variações de escrita que prejudiquem gráficos e filtros.",
      "Use abas extras para informações locais do projeto sem alterar o núcleo do cadastro de aluno.",
      "Exporte relatórios filtrados antes de reuniões pedagógicas para trabalhar apenas com o público-alvo do acompanhamento."
    ],
    "related": [
      "Gestão de Alunos",
      "Painel analítico do dashboard",
      "Personalização de relatórios na Central"
    ]
  },
  {
    "id": "attendee-management-overview",
    "title": "Navegar na Gestão de Atendidos",
    "category": "Gestão de Atendidos",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Gestão de Atendidos",
    "order": 51,
    "aliases": [
      "gestão de atendidos",
      "atendidos",
      "grupos de atendidos"
    ],
    "questions": [
      "Onde ficam as turmas e os grupos de atendidos?",
      "Onde encontro o histórico de frequência dos atendidos?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Use as áreas internas da Gestão de Atendidos conforme as permissões atribuídas à sua conta.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso ao menu Gestão de Atendidos e às áreas internas desejadas."
    ],
    "steps": [
      "No menu lateral do Dashboard, abra “Gestão de Atendidos”.",
      "Use “Dashboard” para o painel do módulo.",
      "Abra “Atendidos” para os cadastros disponibilizados ao seu perfil.",
      "Use “Turmas” e “Cursos” para a organização do atendimento, quando autorizadas.",
      "Abra “Diário de Classe” e, dentro dele, “Frequência”; consulte o histórico pelo diário quando autorizado.",
      "Abra “Configurações” apenas quando a área estiver autorizada para sua conta."
    ],
    "rules": [
      "A área de Atendidos depende de acesso aos dados de DP ou aos dados completos.",
      "Turmas e Cursos dependem das permissões específicas de visualização dessas áreas.",
      "Diário de Classe e seus registros dependem das permissões correspondentes.",
      "O nome da área é “Cursos”. Não confundir com “Grupo/Permissões”, que pertence a Configurações."
    ],
    "expectedResult": "A área interna escolhida é aberta quando estiver disponível ao perfil.",
    "errors": [
      "Se uma área não aparecer, confira as permissões da Gestão de Atendidos; as permissões da Gestão de Alunos não devem ser presumidas equivalentes."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "attendee-management-reports-settings",
    "title": "Relatórios e configurações da Gestão de Atendidos",
    "category": "Atendidos",
    "audience": "Gestores",
    "journeyStage": "Administração",
    "accessPath": "Gestão de Atendidos → Configurações / Aba de Consulta",
    "attention": "Configurações alteram comportamento operacional do módulo; revise baixa frequência, colunas e listas com a coordenação antes de salvar mudanças amplas.",
    "order": 52,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Personalize baixa frequência, mensagens, gráficos, opções de cadastro, colunas de consulta, abas extras e exportações em PDF ou Excel.",
    "whenToUse": [
      "Ajustar regras operacionais de acompanhamento de faltas, motivos de saída, escolas e CRAS de referência.",
      "Gerar consultas e relatórios com colunas específicas para coordenação, parceiros ou prestação de contas."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Abra Configurações dentro da Gestão de Atendidos e defina se a baixa frequência ficará ativa e após quantas faltas o atendido deve ser inativado automaticamente.",
      "Personalize a mensagem de WhatsApp usando variáveis como {atendido}, {faltas} e {dias}, e cadastre e-mails que receberão notificações de baixa frequência.",
      "Escolha os widgets exibidos no dashboard, como ativos x inativos, inscrições, gênero, idade, turma, curso, CRAS, escola e motivos de saída.",
      "Mantenha listas de CRAS, escolas e motivos de saída; use renomeações quando precisar padronizar dados já existentes.",
      "Configure as colunas padrão da Aba de Consulta e, quando necessário, crie abas extras com campos de texto, texto longo, checkbox ou combobox.",
      "Na Aba de Consulta, aplique busca rápida e filtros avançados por nome, CPF, WhatsApp, e-mail, datas, status, motivo de saída e turma.",
      "Antes de exportar PDF ou Excel, selecione as colunas desejadas; acima de sete colunas, o relatório organiza cada atendido em blocos para preservar a leitura."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Revise periodicamente listas de escolas, CRAS e motivos de saída para evitar variações de escrita que prejudiquem gráficos e filtros.",
      "Use abas extras para informações locais do projeto sem alterar o núcleo do cadastro de atendido.",
      "Exporte relatórios filtrados antes de reuniões pedagógicas para trabalhar apenas com o público-alvo do acompanhamento."
    ],
    "related": [
      "Gestão de Atendidos",
      "Painel analítico do dashboard",
      "Personalização de relatórios na Central"
    ]
  },
  {
    "id": "assistant-ai",
    "title": "Assistente IA do Studio",
    "category": "Inteligência",
    "audience": "Gestores",
    "journeyStage": "Início rápido",
    "accessPath": "Assistente IA do Studio",
    "order": 53,
    "status": "migrated",
    "verifiedAt": null,
    "aliases": [],
    "questions": [],
    "summary": "Cocrie processos completos respondendo às perguntas do assistente e receba formulários, fluxos BPMN e recomendações automáticas.",
    "whenToUse": [
      "Iniciar a modelagem de um novo processo com apoio guiado.",
      "Gerar rapidamente formulário, regras e fluxo para validar uma ideia com o time."
    ],
    "prerequisites": [
      "A disponibilidade da tela e das ações depende das permissões da conta."
    ],
    "steps": [
      "Acesse o módulo Assistente IA do Studio para visualizar o painel com progresso e etapas da jornada.",
      "Responda às perguntas exibidas na seção “Conversa com o assistente”; utilize sugestões rápidas quando estiver sem inspiração.",
      "Acompanhe o indicador de progresso para saber quantas etapas faltam e ajuste respostas antes de avançar.",
      "Ao finalizar, revise o resumo gerado, os componentes de formulário e o diagrama BPMN sugerido.",
      "Use o botão “Iniciar nova orientação” para reiniciar o fluxo e criar outra versão ou processo."
    ],
    "rules": [],
    "expectedResult": "Não documentado; não inferir.",
    "errors": [],
    "tips": [
      "Você pode pausar a conversa; o assistente mantém o progresso e os rascunhos gerados até que a orientação seja concluída.",
      "Aplique os artefatos gerados diretamente nos módulos Formulários e Processos para acelerar a publicação."
    ],
    "related": [
      "Modelagem de processos",
      "Construtor de formulários",
      "Painel analítico do dashboard"
    ]
  },
  {
    "id": "customer-shared-registry",
    "title": "Manter o mesmo cadastro de cliente nos módulos",
    "category": "Meu Negócio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Meu Negócio → Clientes",
    "order": 157,
    "aliases": [
      "cadastro único",
      "cadastro compartilhado",
      "empresas de jovem aprendiz",
      "mudou em um mudou em todos",
      "sincronização automática"
    ],
    "questions": [
      "Se alterar uma empresa no Jovem Aprendiz, muda em Clientes?",
      "Como manter o mesmo cadastro no Financeiro e em Clientes?",
      "Como vincular uma oportunidade CRM ao cliente?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Clientes, Financeiro e Empresas do Jovem Aprendiz mantêm o mesmo conjunto de cadastros reais, inclusive com CPF ou sem documento. Salvar os campos comuns em uma tela atualiza o cadastro nas demais.",
    "whenToUse": [
      "Corrigir nome, documento, endereço ou contatos de um cliente nos módulos integrados."
    ],
    "prerequisites": [
      "Ter autorização de edição na tela utilizada. O compartilhamento não libera acesso a outros módulos.",
      "Para associar automaticamente registros existentes, informar o mesmo CPF/CNPJ válido. Nome igual não identifica um cliente."
    ],
    "steps": [
      "Abra “Meu Negócio → Clientes” e localize o cadastro. Empresas existentes no Financeiro e no Jovem Aprendiz já são inscritas pela atualização do sistema.",
      "Edite os campos comuns e clique em “Salvar cliente”. Também é possível salvar a edição pelo Financeiro ou por “Gestão de Aprendiz → Empresas”, conforme acesso.",
      "Confira “Integrações vinculadas”: os vínculos Financeiro e Jovem Aprendiz indicam “Atualização automática ao salvar”. Não é necessário outro envio.",
      "No CRM, ao cadastrar ou editar uma oportunidade, selecione “Cliente compartilhado”. Ao salvar, alterações em Empresa e e-mail atualizam esse cliente.",
      "Confira a atualização nas outras abas ou sessões conectadas. As listas recebem aviso após a confirmação da gravação. Formulários que já estavam em edição preservam seu conteúdo; reabra a ficha para consultar os dados atuais."
    ],
    "rules": [
      "Compartilha razão social/nome, nome fantasia, CPF/CNPJ, logradouro, número, complemento, bairro, cidade, UF, CEP, telefones e e-mails. Ativo/inativo é compartilhado nos três cadastros.",
      "Todo cliente real recebe cadastro vinculado em Financeiro e Empresas do Jovem Aprendiz, mesmo sem documento ou com CPF. O vínculo interno mantém a identidade sem depender do documento. Documentos válidos iguais identificam registros existentes; nomes iguais, sozinhos, não unem pessoas distintas. O seletor técnico Sem empresa e empregadores provisórios Conere sem identidade não são clientes reais.",
      "Financeiro exibe o nome fantasia quando houver e mantém a razão social separada.",
      "São permitidos até 50 contatos por tipo; um telefone e um e-mail são padrão. Preferências de envio de fatura são preservadas para e-mails mantidos.",
      "Observações, dados dos contratos de aprendiz, códigos Conere, WhatsApps específicos do módulo e padrões individuais de serviço conservam suas próprias regras.",
      "Na primeira conciliação, valores já preenchidos em Clientes têm prioridade; contatos válidos das origens são reunidos. Depois, salvar um campo comum atualiza os destinos vinculados.",
      "Oportunidades antigas de texto livre exigem seleção explícita de Cliente compartilhado. Conversas CRM vinculadas exibem o nome atual sem trocar o destinatário externo das mensagens.",
      "Não reescreve documentos fiscais salvos nem respostas históricas de formulários. Não emite notas fiscais.",
      "As listas recebem atualizações do servidor após o commit, inclusive em outras janelas e dispositivos conectados. Em desconexão, a conexão é refeita e as listas são atualizadas novamente. Permissões são reavaliadas a cada reconexão; a notificação não contém dados pessoais.",
      "Empresas do Jovem Aprendiz abre sem restringir a situação a Ativas. Filtros e paginação podem mostrar recortes diferentes do mesmo catálogo; use Todas e limpe a pesquisa para comparar. Clientes, CRM e os clientes disponíveis no Gerenciador NFS percorrem as páginas da API e não param nos primeiros 300.",
      "Ter o mesmo catálogo não cria oportunidades comerciais nem reescreve conversas, contratos ou documentos históricos."
    ],
    "expectedResult": "Os cadastros vinculados apresentam os mesmos campos comuns depois de salvar e atualizar a consulta.",
    "errors": [
      "“Este cliente já está cadastrado neste módulo. Edite o cadastro existente.”: localize o documento no catálogo e edite a ficha existente, evitando duplicar a mesma identidade.",
      "“Informe CPF com 11 dígitos ou CNPJ com 14 dígitos.”: revise a quantidade de dígitos ou deixe o documento em branco quando ainda não estiver disponível.",
      "“Este cadastro já pertence a outro cliente. Confira o CPF/CNPJ e os vínculos.”: revise documento e associação antes de salvar.",
      "Se um destino falhar, a gravação local é desfeita para evitar atualização parcial. Corrija o erro apresentado e tente novamente."
    ],
    "tips": [
      "Confira o CPF/CNPJ antes de alterar: empresas de nomes parecidos podem ser pessoas jurídicas distintas."
    ],
    "related": [
      "Importar clientes por planilha ou módulo.",
      "Abrir Padrões gerais de notas."
    ]
  },
  {
    "id": "customer-general-defaults",
    "title": "Abrir Padrões gerais de notas",
    "category": "Meu Negócio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Meu Negócio → Clientes → Padrões gerais → Dados Cadastrais → Fiscal e alíquota da empresa",
    "order": 158,
    "aliases": [
      "padrões gerais",
      "padroes gerais",
      "tela branca",
      "modelos de notas"
    ],
    "questions": [
      "Onde abre o botão Padrões gerais em Clientes?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "O botão Padrões gerais abre Dados Cadastrais diretamente no painel Fiscal e alíquota da empresa.",
    "whenToUse": [
      "Configurar o serviço, a descrição e os tributos sugeridos nas notas."
    ],
    "prerequisites": [
      "Ter acesso a Clientes e às ações de configuração desejadas, conforme as permissões da conta."
    ],
    "steps": [
      "Acesse “Meu Negócio → Clientes”.",
      "Clique em “Padrões gerais”.",
      "Na aba “Dados Cadastrais”, confira o painel “Fiscal e alíquota da empresa”.",
      "Configure código do serviço e “Descrição geral das notas” e salve o cadastro fiscal. Em “Padrões fiscais gerais”, preencha os códigos e os percentuais de ISS e Simples Nacional e clique em “Salvar padrões”.",
      "Para padrões específicos de uma pessoa ou empresa, volte à ficha do cliente e use “Padrões de serviços deste cliente”."
    ],
    "rules": [
      "O atalho abre uma aba interna com o componente e o painel definidos; não exige novo login.",
      "Código e valor próprios do cliente têm prioridade sobre o modelo geral no preenchimento existente.",
      "Em NBS, INDOP, CST, CCLASSTRIB, ISS e Simples Nacional, cada campo preenchido no cliente prevalece sobre o geral; vazio herda o geral.",
      "O texto do cliente vem antes da descrição geral, omitindo os blocos vazios. Tudo permanece editável na nota.",
      "“Alíquota do ISS (%)” e “Simples Nacional (%)” são independentes. Um campo vazio não copia o percentual do outro.",
      "A retenção do ISS é respondida na emissão de cada nota; salvar uma alíquota padrão não define retenção.",
      "Alterar padrões não emite notas fiscais."
    ],
    "expectedResult": "Dados Cadastrais abre em Fiscal e alíquota da empresa, mantendo a navegação do sistema utilizável.",
    "errors": [
      "“Não foi possível abrir os padrões gerais.”: a falha aparece na própria tela de Clientes, que permanece utilizável; tente abrir novamente ou use Dados Cadastrais pelo menu autorizado."
    ],
    "tips": [
      "Padrões gerais e descrições individuais do cliente são configurações diferentes."
    ],
    "related": [
      "Configurar descrições de notas por cliente."
    ]
  },
  {
    "id": "customer-import",
    "order": 159,
    "category": "Meu Negócio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Importar clientes por planilha ou módulo",
    "accessPath": "Meu Negócio → Clientes → Importar / Vincular",
    "aliases": [
      "clientes",
      "cliente",
      "importar clientes",
      "planilha de clientes",
      "CPF/CNPJ"
    ],
    "questions": [
      "Como importar clientes por planilha?",
      "Como vincular um cliente do Financeiro?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Importe clientes usando os modelos e as etapas de conferência, preservando os vínculos com os módulos de origem.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso a Clientes e autorização para importar e consultar o módulo de origem."
    ],
    "steps": [
      "Abra “Meu Negócio → Clientes → Importar / Vincular”.",
      "Para planilha, baixe o modelo XLSX oficial com as abas Clientes e Instruções.",
      "Preencha os dados e preserve CPF/CNPJ como texto para manter zeros à esquerda. Anexe a planilha e clique em “Conferir planilha”.",
      "Revise erros e duplicidades. Somente então use “Confirmar importação”.",
      "Para importar por módulo, escolha Financeiro, Jovem Aprendiz ou CRM, pesquise a origem, marque os registros desejados e confirme. Financeiro e Empresas do Jovem Aprendiz já participam automaticamente do cadastro compartilhado; confira vínculos existentes antes de importar.",
      "Confira o retorno com clientes criados, vinculados, já vinculados e erros individuais."
    ],
    "rules": [
      "A planilha pode ter até 2 MB e 500 clientes.",
      "A importação XLSX exige CPF/CNPJ válido; rejeita fórmulas e cabeçalhos incompatíveis e ignora clientes existentes.",
      "A importação por módulo permite selecionar até 200 registros de várias páginas.",
      "CPF/CNPJ igual vincula registros; vínculos existentes não são duplicados.",
      "Importar e vincular não substituem valores preenchidos localmente.",
      "Salvar um cadastro compartilhado atualiza automaticamente os campos comuns de Clientes, Financeiro e Empresas do Jovem Aprendiz vinculadas. Importar não emite notas fiscais."
    ],
    "expectedResult": "Clientes importados ou vinculados, com relatório das operações e eventuais erros.",
    "errors": [
      "Corrija erros e duplicidades apresentados na conferência antes de confirmar.",
      "Para cliente sem documento, use a ficha individual ou a importação por módulo autorizada."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "customer-service-descriptions",
    "order": 159,
    "category": "Meu Negócio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Configurar descrições de notas por cliente",
    "accessPath": "Meu Negócio → Clientes → Padrões de serviços deste cliente → Descrições de notas",
    "aliases": [
      "descrição de nota",
      "descrições de notas",
      "padrão de serviço",
      "padrões de serviços",
      "competência"
    ],
    "questions": [
      "Como salvar descrições de notas para um cliente?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Guarde descrições nomeadas por cliente para sugerir o preenchimento no rascunho do Gerenciador NFS.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso ao cliente e autorização de edição."
    ],
    "steps": [
      "Abra a ficha do cliente e localize “Padrões de serviços deste cliente → Descrições de notas”.",
      "Cadastre o texto nomeado e, se desejado, marque-o como “Principal”.",
      "Use as variáveis permitidas quando quiser preencher cliente ou competência automaticamente.",
      "Salve a ficha. Ao selecionar esse cliente no Gerenciador NFS, revise o texto do cliente seguido da descrição geral da empresa, quando preenchidos.",
      "Se necessário, escolha outra descrição ou edite o texto do rascunho antes de prosseguir."
    ],
    "rules": [
      "Cada cliente pode ter até 10 descrições nomeadas e apenas uma principal.",
      "As variáveis permitidas são {{cliente}}, {{competencia}}, {{mes}} e {{ano}}.",
      "Cada padrão tem limite de 4.000 caracteres. A descrição final para emissão deve caber em 2.000 caracteres, conforme o leiaute DPS.",
      "Em “Padrões de serviços deste cliente”, também é possível salvar NBS, INDOP, CST, CCLASSTRIB, alíquota do ISS e percentual do Simples Nacional. Campos em branco herdam o geral; zero é uma alíquota explícita.",
      "Na conferência de emissão, “Tributação” permite revisar códigos e percentuais; “Ajustar serviço e descrição” permite alterar o serviço e o texto somente naquela nota, sem modificar os padrões.",
      "Alterações manuais no rascunho não são sobrescritas pela atualização automática da competência ou do nome.",
      "Salvar um padrão não transmite nem emite nota fiscal."
    ],
    "expectedResult": "O padrão fica disponível para preenchimento de rascunhos, preservando a versão utilizada em documentos existentes.",
    "errors": [
      "Se o texto ultrapassar 4.000 caracteres ou utilizar conteúdo inválido, corrija-o antes de salvar."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "form-field-validation",
    "order": 159,
    "category": "Studio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Adicionar campos e corrigir validações do formulário",
    "accessPath": "Studio → Formulários → Construtor de formulários",
    "aliases": [
      "campo",
      "campos",
      "id duplicado",
      "largura do campo",
      "lista",
      "tabela"
    ],
    "questions": [
      "Por que não consigo salvar um campo?",
      "Como configurar campos obrigatórios?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Configure cada campo no construtor respeitando identificação, largura e opções exigidas pelo tipo.",
    "whenToUse": [],
    "prerequisites": [
      "Ter permissão para gerenciar formulários.",
      "Estar com um formulário aberto no construtor."
    ],
    "steps": [
      "Adicione ou edite o campo desejado no construtor.",
      "Preencha o nome e o ID do campo.",
      "Defina a largura entre 1 e 12.",
      "Para lista sem opções acadêmicas integradas, adicione ao menos uma opção. Para tabela, adicione ao menos uma coluna.",
      "Confirme o campo e, ao concluir o formulário, salve o formulário."
    ],
    "rules": [
      "O nome e o ID do campo são obrigatórios.",
      "O ID deve ser único no formulário.",
      "A largura deve estar entre 1 e 12.",
      "Listas sem opções acadêmicas integradas precisam de ao menos uma opção.",
      "Tabelas precisam de ao menos uma coluna."
    ],
    "expectedResult": "O campo passa a fazer parte da estrutura do formulário.",
    "errors": [
      "“Nome e ID do campo são obrigatórios”: complete os dois valores.",
      "“ID do campo duplicado”: use um ID diferente dos demais campos.",
      "“A largura do campo deve estar entre 1 e 12.”: ajuste a largura.",
      "“Adicione ao menos uma opção para campos do tipo lista.”: preencha as opções.",
      "“Adicione ao menos uma coluna para o campo de tabela.”: configure uma coluna."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "form-module-data",
    "order": 159,
    "category": "Studio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Preencher campos com dados de um módulo",
    "accessPath": "Studio → Formulários → Construtor → Campo vinculado → Dados de um módulo",
    "aliases": [
      "dados de um módulo",
      "campo vinculado",
      "vincular módulo",
      "preenchimento por módulo",
      "module mappings"
    ],
    "questions": [
      "Como preencher um formulário com dados de um módulo?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Use a origem “Dados de um módulo” em um campo vinculado para selecionar um registro e preencher campos de destino.",
    "whenToUse": [],
    "prerequisites": [
      "Ter permissão de gerenciamento de formulários e acesso aos registros do módulo de origem.",
      "Existirem os campos de destino no mesmo formulário."
    ],
    "steps": [
      "No construtor de formulários, adicione ou edite um campo vinculado.",
      "Selecione a origem “Dados de um módulo”.",
      "Selecione o módulo de origem e o identificador do registro.",
      "Para cada vínculo, selecione o dado de origem e um campo de destino existente.",
      "Confirme o campo e salve o formulário.",
      "Na execução, selecione um registro autorizado e confira os dados preenchidos antes de enviar a etapa."
    ],
    "rules": [
      "Módulo e identificador do registro são obrigatórios nessa origem.",
      "Cada vínculo precisa de origem e destino preenchidos.",
      "O destino deve ser um campo existente e diferente do próprio campo vinculado.",
      "Cada campo de destino recebe apenas um dado do módulo.",
      "A seleção não concede acesso a registros que a pessoa não está autorizada a consultar."
    ],
    "expectedResult": "A configuração do vínculo é salva; a seleção de um registro na execução preenche os destinos configurados.",
    "errors": [
      "“Selecione o módulo e o identificador do registro.”: complete a origem.",
      "“Complete cada vínculo com o dado de origem e o campo de destino.”: revise os mapeamentos.",
      "“Cada campo de destino deve receber apenas um dado do módulo.”: remova destinos repetidos."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "signature-identification",
    "order": 159,
    "category": "Assinaturas",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Concluir a identificação para assinaturas",
    "accessPath": "Meu Negócio → Assinaturas",
    "aliases": [
      "assinaturas",
      "assinatura",
      "identificação",
      "selfie",
      "documento com foto",
      "análise de identidade"
    ],
    "questions": [
      "Como habilitar minha conta para assinar?",
      "Por que a identificação aparece ao abrir Assinaturas?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "A conta precisa concluir sua identificação antes de acessar o conteúdo de Assinaturas quando a aprovação estiver pendente.",
    "whenToUse": [],
    "prerequisites": [
      "Estar autenticado e possuir as permissões do módulo.",
      "Ter documento com foto e condições de capturar a selfie solicitada."
    ],
    "steps": [
      "Abra “Meu Negócio → Assinaturas”.",
      "Se houver identificação pendente, siga o fluxo “Identificação → Documento → Selfie → Análise → Conclusão”.",
      "Confira nome e CPF vindos do cadastro. Informe uma data de nascimento válida quando solicitada.",
      "Apresente o documento e capture a selfie conforme as orientações da tela.",
      "Acompanhe a análise e as instruções de conclusão ou correção apresentadas."
    ],
    "rules": [
      "O conteúdo do módulo é montado após a aprovação da identificação exigida.",
      "Fechar a aba, reabrir ou recarregar não dispensa a identificação pendente.",
      "Uma data de nascimento já cadastrada não é substituída silenciosamente.",
      "O aceite deve ser dado pelo próprio usuário antes do primeiro arquivo.",
      "A aprovação da identidade não significa que um documento já foi assinado."
    ],
    "expectedResult": "Identificação concluída e, após aprovação, acesso ao conteúdo autorizado de Assinaturas.",
    "errors": [
      "Se a análise indicar correção, siga o motivo exibido antes de reenviar. Não presuma aprovação pelo simples envio das fotos."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "student-record-validation",
    "order": 159,
    "category": "Gestão de Alunos",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Corrigir erros de cadastro de aluno",
    "accessPath": "Gestão de Alunos → Alunos",
    "aliases": [
      "aluno",
      "alunos",
      "cadastro de aluno",
      "CPF de aluno",
      "turma ativa",
      "RA"
    ],
    "questions": [
      "Como corrigir o CPF do aluno?",
      "Por que não consigo salvar o aluno?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Confira os dados pessoais e o vínculo acadêmico quando o cadastro de um aluno for rejeitado.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso à Gestão de Alunos e permissão para alterar o cadastro.",
      "Identificar o aluno correto antes de editar."
    ],
    "steps": [
      "Abra a ficha do aluno na Gestão de Alunos.",
      "Confira “Nome completo” e o CPF, quando informado.",
      "Confira o RA e, se houver vínculo acadêmico, o curso e a turma.",
      "Ao trocar a turma, escolha uma turma ativa compatível com o curso.",
      "Salve e confira a mensagem retornada. Se houver rejeição, corrija o campo indicado antes de tentar novamente."
    ],
    "rules": [
      "Nome completo é obrigatório.",
      "CPF informado deve ter 11 dígitos; um CPF já cadastrado não pode ser reutilizado por outro aluno.",
      "RA deve ter no máximo 40 caracteres.",
      "Ao mudar a turma, a nova turma precisa estar ativa.",
      "A turma selecionada deve pertencer ao curso informado.",
      "No modo Jovem Aprendiz, a ficha fica em “Gestão de Aprendiz → Atendidos”; o vocabulário exibido muda conforme esse modo.",
      "As abas e os dados disponíveis na ficha dependem das permissões do usuário."
    ],
    "expectedResult": "Cadastro salvo com dados válidos e vínculo acadêmico consistente.",
    "errors": [
      "“CPF deve conter 11 dígitos.”: confira os dígitos do CPF.",
      "“Já existe um aluno cadastrado com este CPF.”: localize o cadastro existente antes de criar outro.",
      "“RA deve ter no máximo 40 caracteres.”: reduza o identificador.",
      "“Selecione uma turma ativa.”: escolha uma turma ativa para o novo vínculo.",
      "“A turma selecionada não pertence ao curso.”: corrija a combinação de curso e turma."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "form-signature-submit",
    "order": 160,
    "category": "Processos",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Enviar formulário com documento assinado",
    "accessPath": "Solicitação → Formulário → Documento para assinatura",
    "aliases": [
      "erro ao enviar formulário",
      "dados mudaram",
      "documento para assinatura"
    ],
    "questions": [
      "Por que o formulário pede uma nova versão para assinatura?",
      "Como enviar uma etapa com documento assinado?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Conclua as assinaturas exigidas antes de enviar uma etapa interna. O servidor confere o vínculo com a solicitação, a etapa, os dados e a integridade do documento.",
    "whenToUse": [
      "Quando a etapa apresentar um campo de documento com assinatura habilitada."
    ],
    "prerequisites": [
      "Estar autenticado, ter acesso à solicitação e estar autorizado a concluir a etapa.",
      "Os destinatários da assinatura no formulário precisam ter conta no sistema."
    ],
    "steps": [
      "Preencha e confira os dados do formulário antes de gerar o documento.",
      "No campo de assinatura, gere o PDF ou anexe o documento e solicite a assinatura.",
      "Conclua as assinaturas necessárias e confira o estado exibido no campo.",
      "Aguarde os uploads de arquivos terminarem e clique em “Enviar”.",
      "Se aparecer “Restaurar dados assinados”, use essa ação para recuperar as respostas comprovadas da versão assinada, confira e clique novamente em “Enviar”. A ação não cria outra assinatura nem envia automaticamente.",
      "Se precisar manter dados alterados após a criação da assinatura, abra “Precisa alterar o documento?” e clique em “Criar nova versão”; conclua as novas assinaturas antes de enviar."
    ],
    "rules": [
      "A assinatura no formulário está disponível somente em etapas internas, com usuário autenticado.",
      "Novas solicitações de assinatura tratam campo vazio não preenchido, nulo e texto vazio como a mesma resposta. Tabela ausente e tabela sem linhas também são equivalentes; células vazias são normalizadas dentro das linhas existentes.",
      "Alterar conteúdo preenchido, arquivos, quantidade ou ordem das linhas continua exigindo uma nova versão. A atualização do estado da própria assinatura não altera o vínculo com os dados.",
      "Em assinaturas antigas, o servidor tenta reconhecer diferenças apenas na representação de respostas vazias, comparando cada alternativa com o hash original. Se uma alternativa corresponder, a etapa pode avançar sem gerar outra versão; o documento e as evidências originais permanecem intactos. Essa tentativa tem limites de processamento e não aceita mudanças em respostas preenchidas, arquivos ou linhas.",
      "Documento concluído na etapa anterior pode ser reaproveitado se pertence à mesma solicitação e campo, mantém respostas equivalentes e passa pela conferência de integridade. Na assinatura progressiva, a exigência de outro assinante continua válida.",
      "A recuperação só aparece quando as respostas salvas ou históricas correspondem integralmente ao hash original e a integridade da assinatura concluída é confirmada. Restaura somente diferenças em campos editáveis da etapa, sem mudar o documento ou as evidências; campos condicionais, bloqueados ou recuperação acima dos limites não são oferecidos.",
      "O estado de assinatura recebido do navegador não dispensa a validação do servidor.",
      "Quando a configuração permite aguardar a conclusão, o envio salva os dados e a etapa continua automaticamente após as assinaturas."
    ],
    "expectedResult": "A etapa avança após as validações ou permanece aguardando assinaturas, conforme a configuração.",
    "errors": [
      "“Os dados de \"{campo}\" mudaram. Gere uma nova versão para assinatura.”: confira se houve mudança em dados preenchidos. Se disponível, use “Restaurar dados assinados” para retornar às respostas assinadas e envie novamente; para manter dados diferentes, use “Criar nova versão”. Se uma assinatura antiga continuar sem validação, a compatibilidade com respostas vazias pode ter atingido seu limite de processamento. A assinatura anterior é preservada.",
      "“Falha de integridade no documento assinado.”: encaminhe a falha ao suporte para conferir o armazenamento e as evidências.",
      "Upload em andamento: aguarde a conclusão antes de enviar o formulário."
    ],
    "tips": [
      "Preencha os dados e envie os arquivos antes de gerar a versão que será assinada."
    ],
    "related": [
      "Concluir a identificação para assinaturas."
    ]
  },
  {
    "id": "process-form-submission-print",
    "order": 160,
    "category": "Operações",
    "audience": "Usuários de processos",
    "journeyStage": "Execução diária",
    "title": "Enviar formulários e baixar a ficha da solicitação",
    "accessPath": "Solicitações → Abrir solicitação → Enviar / Baixar PDF",
    "aliases": [
      "ficha do formulário",
      "imagem na ficha",
      "conclusão de processo"
    ],
    "questions": [
      "Como aparecem os anexos e as fotos na ficha PDF?",
      "Como fechar a tela de processo concluído?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Preencha uma etapa e envie a solicitação; baixe a ficha com os nomes dos arquivos anexados.",
    "whenToUse": [
      "Registrar dados em uma solicitação ou guardar uma cópia da ficha em PDF."
    ],
    "prerequisites": [
      "Ter acesso à solicitação e autorização para executar a etapa; o link externo segue as configurações de acesso público existentes.",
      "Aguardar o término dos uploads e preencher os campos obrigatórios antes do envio."
    ],
    "steps": [
      "Preencha os campos disponíveis e confira os anexos.",
      "Use “Enviar” na execução interna ou “Enviar solicitação” no formulário externo.",
      "Quando o processo interno terminar, a tela mostra “Processo concluído” por três segundos e retorna à primeira aba, Dashboard; o controle de fechar permite antecipar esse retorno.",
      "No formulário externo, a confirmação mantém o número da solicitação e a ação “Enviar nova solicitação”.",
      "Use “Baixar PDF” na solicitação ou “Imprimir ficha” na página do cadastro acessada pelo menu para salvar a ficha."
    ],
    "rules": [
      "O envio continua sujeito às validações existentes e aguarda os uploads pendentes; cliques repetidos durante um envio não iniciam outro envio na mesma tela.",
      "O formulário interno agrupa gravações do rascunho durante a edição e tenta salvar o último valor ao sair; limitações de armazenamento do navegador podem impedir o rascunho local.",
      "A ficha imprime nomes de anexos e fotos, inclusive em listas e tabelas, sem incluir conteúdo base64 ou metadados internos dos arquivos. Quando somente o identificador do armazenamento está disponível, mostra “Arquivo anexado”, sem apresentar o código como nome.",
      "Documentos com assinatura aparecem pelo nome original, quando salvo; sem nome, usam uma descrição em português, como “Documento assinado” ou “Aguardando assinatura”. A ficha não imprime status em inglês, versão, hashes, identificadores ou códigos internos de verificação.",
      "Respostas Sim/Não são impressas em português. Objetos sem descrição legível mostram “Informação não disponível”, sem listar suas propriedades internas.",
      "Novas fotos preservam o nome do arquivo no formulário. Fotos antigas sem nome salvo usam o rótulo do campo e a extensão reconhecida; o nome original não pode ser recuperado do base64.",
      "Os catálogos de cursos, grupos e turmas necessários são consultados sem cache persistente; as consultas independentes são feitas em paralelo.",
      "O título da solicitação usa fundo azul escuro e letras brancas; os botões Enviar e Baixar PDF usam azul escuro.",
      "A ficha em Baixar PDF apresenta cabeçalho azul escuro, identificação organizada em cartões, grupos e paginação.",
      "Ao abrir a solicitação, o carregamento mostra uma prévia visual dos blocos e uma barra animada enquanto os dados são recebidos; não há porcentagem simulada.",
      "Um documento concluído em etapa anterior pode ser reaproveitado sem nova assinatura quando pertence à mesma solicitação e campo, mantém os mesmos dados e passa pela conferência de integridade. A assinatura progressiva continua exigindo o próximo assinante quando configurada.",
      "A atualização automática de assinaturas usa apenas o status, pausa com a página oculta e termina após conclusão ou encerramento. A conferência de integridade continua nas ações de consulta completa, download e envio da etapa."
    ],
    "expectedResult": "- A confirmação aparece após o retorno bem-sucedido do envio; a ficha contém os nomes dos anexos e os demais valores preenchidos.",
    "errors": [
      "Aguarde o término dos arquivos pendentes antes de tentar enviar novamente.",
      "Corrija os campos indicados pelas validações e tente novamente.",
      "“Os dados de \"campo\" mudaram. Gere uma nova versão para assinatura.”: os dados atuais não correspondem à versão vinculada ao documento. Quando o servidor encontra respostas salvas ou históricas comprovadamente iguais às assinadas e passíveis de edição nesta etapa, aparece “Restaurar dados assinados”. Clique para substituir essas respostas, confira e use “Enviar” novamente; a restauração não envia automaticamente. Sem recuperação disponível, o campo abre “Criar nova versão”. Use essa opção se precisar manter dados diferentes; a assinatura anterior permanece preservada."
    ],
    "tips": [
      "Confira o número da solicitação na confirmação externa para acompanhamento com a equipe."
    ],
    "related": [
      "Formulários externos e pré-visualização",
      "Preencher campos com dados de um módulo"
    ]
  },
  {
    "id": "student-attendance",
    "order": 160,
    "category": "Gestão de Alunos",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Registrar frequência dos alunos",
    "accessPath": "Gestão de Alunos → Diário de Classe → Frequência",
    "aliases": [
      "frequência",
      "frequencia",
      "chamada",
      "faltas",
      "atestados",
      "justificativas",
      "tema da aula"
    ],
    "questions": [
      "Como registrar frequência?",
      "Por que não consigo alterar uma falta?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Preencha a frequência da turma e os dados pedagógicos exigidos. Alterações em faltas e justificativas têm autorização específica.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso à frequência e permissão para a operação.",
      "Para registrar ou alterar faltas, justificativas e atestados, possuir a autorização específica correspondente."
    ],
    "steps": [
      "Abra “Gestão de Alunos → Diário de Classe → Frequência”.",
      "Selecione a turma e a data do registro.",
      "Preencha “Tema da aula” e “Objetivo”, além dos demais dados exigidos na tela.",
      "Preencha a situação de frequência de todos os alunos apresentados.",
      "Revise os registros e confirme o salvamento.",
      "Consulte o histórico pelo diário para acessar registros anteriores, conforme sua permissão."
    ],
    "rules": [
      "No modo Jovem Aprendiz, o caminho é “Gestão de Aprendiz → Atendidos → Diário de Atividades → Frequência”.",
      "Todos os alunos enviados precisam ter frequência preenchida.",
      "Tema da aula e objetivo são obrigatórios.",
      "Registrar ou alterar situação de falta ou justificada exige permissão de gerenciamento de atestados e ausências ou administração.",
      "Alterar um registro que já continha falta ou justificativa também está sujeito à restrição."
    ],
    "expectedResult": "Frequência salva para a turma/data com os dados pedagógicos e as situações dos alunos.",
    "errors": [
      "“Todos os alunos devem ter frequência preenchida.”: confira se todos os alunos têm uma situação.",
      "“Tema da aula é obrigatório.” ou “Objetivo é obrigatório.”: complete o dado pedagógico indicado.",
      "“Você não tem permissão para registrar ou alterar faltas, justificativas e atestados.”: solicite a conferência da autorização, sem tentar contornar o bloqueio."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "nfse-emission",
    "order": 161,
    "category": "Meu Negócio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Conferir emissão de NFS-e e conciliar uma DPS",
    "accessPath": "Meu Negócio → Gerenciador NFS",
    "aliases": [
      "NFS-e",
      "Gerenciador NFS",
      "nota fiscal",
      "emitir nota",
      "DPS",
      "conciliar DPS",
      "alíquota do ISS",
      "ISS retido",
      "Simples Nacional"
    ],
    "questions": [
      "Salvar rascunho emite uma nota fiscal?",
      "O que fazer quando a nota fica com conciliação necessária?",
      "Como informar ISS retido pelo tomador sem confundir com o Simples Nacional?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Diferencie rascunho, conferência e emissão fiscal. Um retorno incerto exige conciliação antes de qualquer nova tentativa.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso ao Gerenciador NFS com permissão GERENCIAR_EMPRESA.",
      "Para transmissão, o ambiente e as liberações de emissão precisam estar configurados, com certificado A1 utilizável e habilitação fiscal do contribuinte.",
      "Em produção, a emissão manual descrita exige usuário master e as liberações explícitas do servidor."
    ],
    "steps": [
      "Abra “Meu Negócio → Gerenciador NFS” e localize a nota em “Documentos”, ou use “Nova nota” para preparar um rascunho.",
      "Confira se o registro é um rascunho; salvar um rascunho não transmite uma nota ao governo.",
      "Quando a emissão estiver disponível, abra “Emitir nota” e confira o resumo e os padrões do cliente ou, nos campos vazios, os gerais. Em “Tributação”, responda “ISS retido pelo tomador?” e confira o município do serviço. Se retido, preencha a alíquota do ISS. Use “Ajustar serviço e descrição” para editar o serviço ou texto somente da nota.",
      "Revise a prévia da DPS: identificação e CPF/CNPJ de emitente e tomador, competência, serviço, descrição final, valor e tributos. Somente então confirme o envio.",
      "Após a confirmação, confira o estado retornado. Somente a autorização fiscal oficial confirma a emissão no ambiente correspondente.",
      "Se aparecer “Conciliação necessária”, utilize “Conciliar DPS na SEFIN”. Não crie outra numeração para repetir o envio sem esclarecer o resultado anterior."
    ],
    "rules": [
      "Durante a criação ou conferência, a lista de documentos fica oculta para manter o foco no formulário. Fechar retorna à lista.",
      "A sugestão retoma a última série usada internamente pelo iBPM para o emitente e o ambiente; sem emissões internas anteriores, inicia na série 1. Séries reservadas do portal nacional não substituem a série interna.",
      "O próximo número da DPS considera o maior número oficial disponível e as reservas locais da mesma série, inclusive rejeições e cancelamentos. O número da NFS-e continua sendo atribuído pelo governo.",
      "A descrição automática reúne o texto do cliente e o geral, nesta ordem, omitindo os vazios. O rascunho com texto manual é preservado.",
      "NBS tem 9 dígitos; INDOP, 6; CST IBS/CBS, 3; CCLASSTRIB, 6. Para enviar IBS/CBS, preencha INDOP, CST e CCLASSTRIB juntos. Não há códigos fiscais presumidos.",
      "A retenção não vem respondida automaticamente: selecione Sim ou Não em cada emissão. Sem resposta, não há prévia. O servidor também exige a confirmação explícita da retenção; uma sugestão antiga não basta.",
      "O ISS é o percentual municipal relativo ao serviço; o percentual do Simples representa o total aproximado de tributos do Simples.",
      "“Alíquota do ISS (%)” é independente de “Simples Nacional (%)”. Os padrões não transferem valores entre esses campos.",
      "No cenário ME/EPP com apuração do ISS pelo Simples, sem retenção, a DPS não envia pAliq. Com retenção pelo tomador, exige alíquota de ISS entre 1,80% e 5%, em campo separado do total aproximado do Simples.",
      "Serviço, descrição, códigos e alíquotas podem ser ajustados na nota sem reescrever os padrões. A descrição final deve ter até 2.000 caracteres e alterações invalidam a prévia anterior.",
      "Preparar a conferência da DPS não transmite a nota.",
      "O pré-preenchimento usa logradouro, número e bairro do cadastro compartilhado. Alterar número, complemento ou bairro invalida sugestões antigas de endereço; confira os dados antes de enviar.",
      "BPMN, agendamentos e importações criam rascunhos; não emitem automaticamente.",
      "O cenário de emissão documentado é ME/EPP optante do Simples Nacional, serviço tributável, com ISS sem retenção ou retido pelo tomador. Retenção por intermediário e regimes excepcionais continuam fora deste fluxo.",
      "A1 cadastrado, resposta HTTP de sucesso ou PDF interno não comprovam autorização fiscal.",
      "Retorno incerto permanece em PROCESSING, sem repetição automática.",
      "Um 404 na conciliação, isoladamente, não autoriza reenvio.",
      "No ambiente restrito, TEST_AUTHORIZED não equivale a uma autorização em produção."
    ],
    "expectedResult": "Nota com estado fiscal confirmado ou pendência explícita de conciliação, sem duplicar a tentativa incerta.",
    "errors": [
      "“Para ISS retido pelo tomador, informe a alíquota de ISS entre 1,80 e 5%. Não utilize a alíquota total do Simples Nacional.”: confira o ISS aplicável e informe o percentual no campo próprio; o sistema não o calcula a partir do Simples.",
      "“Conciliação necessária”: consulte a DPS na SEFIN e esclareça o resultado antes de nova tentativa.",
      "Se houver rejeição explícita, revise os dados e o motivo apresentado antes de qualquer novo envio.",
      "Se a transmissão estiver bloqueada, confira configuração e habilitação com o responsável fiscal e técnico; não trate o rascunho como nota emitida."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "nfse-consultation",
    "order": 162,
    "category": "Meu Negócio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "title": "Atualizar a situação oficial das notas fiscais",
    "accessPath": "Meu Negócio → Gerenciador NFS",
    "aliases": [
      "ADN",
      "consulta de notas",
      "erro ADN",
      "atualizar notas"
    ],
    "questions": [
      "Como atualizar a situação das notas fiscais?",
      "O que significa uma falha na consulta de eventos do ADN?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "Consulte os eventos oficiais das notas e diferencie falhas de atualização de alterações fiscais confirmadas.",
    "whenToUse": [
      "Para conferir a situação de notas emitidas, inclusive cancelamentos realizados em outro emissor."
    ],
    "prerequisites": [
      "Estar autenticado e ter permissão GERENCIAR_EMPRESA.",
      "Ter certificado A1 disponível e consulta oficial habilitada no ambiente fiscal da nota."
    ],
    "steps": [
      "Abra “Meu Negócio → Gerenciador NFS”.",
      "Clique em “Atualizar”. A tela também consulta ao abrir e a cada 30 segundos enquanto estiver visível.",
      "Confira o horário da consulta e os documentos. O filtro “Período” começa em “Este mês”; escolha “Mês anterior”, “Personalizado” (De/Até) ou “Todo o período” para consultar outras competências.",
      "Se aparecer “Atualização pendente”, expanda os detalhes e confira o motivo retornado.",
      "Após corrigir a pendência indicada ou aguardar a disponibilidade do serviço, clique em “Atualizar” novamente."
    ],
    "rules": [
      "O período usa a competência da nota e o mês de São Paulo. Listagem, métricas e exportação acompanham o recorte; datas são consultadas no banco antes do limite de 200 documentos.",
      "A importação do histórico ADN continua percorrendo os documentos disponíveis independentemente do período visível.",
      "Notas oficiais históricas podem omitir o tomador ou usar identificação estrangeira. A importação conserva CPF/CNPJ/nome ausentes como campos vazios, mantém o XML integral e não cria nem vincula um Cliente sem documento nacional. Isso não dispensa os dados exigidos para novas emissões pelo iBPM.",
      "A atualização também importa automaticamente as NFS-e disponíveis no ADN, emitidas pelo CNPJ cadastrado, preservando chave, número oficial, série e número da DPS. Não depende de importar por chave individualmente.",
      "O histórico é percorrido em lotes limitados, a partir do NSU seguinte ao último processado. Lotes parciais continuam nas próximas atualizações e requisições simultâneas compartilham a mesma importação.",
      "O histórico concluído é conferido novamente em até dois minutos enquanto a tela está visível. A importação manual pode ser usada para uma nova consulta imediata.",
      "A listagem de eventos é consultada no ADN do ambiente correspondente; o registro de eventos usa outra rota.",
      "Metadados opcionais do envelope ADN não comprovam situação fiscal; um cancelamento exige XML com assinatura válida, chave e ambiente correspondentes à nota.",
      "Rejeições do ADN exibem código e descrição oficiais quando fornecidos; lote ausente e XML ausente possuem mensagens específicas.",
      "Uma NFS-e encontrada na distribuição é reconhecida pela chave e pelo ambiente, mas não é tratada como evento nem altera a situação; um cancelamento continua exigindo evento assinado válido.",
      "A verificação XMLDSig usa XMLSec sobre o documento original e aceita canonicalização inclusiva, exclusiva, exclusiva com comentários (WithComments) e a conversão implícita prevista em XMLDSig. Referências externas e transforms não permitidos são recusados.",
      "Uma falha de consulta preserva a situação anterior. Atualizar não emite, reenvia nem cancela documentos.",
      "Resultados parciais continuam nas próximas consultas; ausência de evento não autoriza nova emissão."
    ],
    "expectedResult": "Situação atualizada apenas com confirmação oficial, ou pendência explícita com o estado anterior preservado.",
    "errors": [
      "“O ADN não confirmou o ambiente da consulta de eventos.”: confira o ambiente fiscal configurado para a nota.",
      "“O ADN retornou um evento sem o XML necessário à verificação oficial.”: aguarde e atualize novamente; o sistema não pode confirmar um evento sem verificar o XML.",
      "“O ADN retornou um lote de eventos ausente, inválido ou acima do limite.”: a resposta não pôde ser processada; encaminhe a mensagem ao suporte.",
      "Em uma rejeição “ADN HTTP”, confira o código e a descrição apresentados antes de alterar dados. Falha de atualização não significa rejeição da emissão original.",
      "“O XML recebido não é um evento fiscal registrado (evento).”: o documento retornado tem um formato diferente do evento esperado; encaminhe o retorno ao suporte.",
      "“O XSD oficial de eventos não pôde ser carregado no servidor. Verifique a instalação do validador.”: é uma falha de instalação do servidor, que deve ser corrigida pelo suporte.",
      "“A estrutura do evento recebido não corresponde ao XSD oficial v1.01.”: encaminhe o retorno ao suporte para conferir o leiaute; não altere a situação da nota manualmente.",
      "“A assinatura ou o digest do evento recebido não pôde ser validado.”: a atualização não pode ser confirmada; encaminhe o retorno ao suporte sem reenviar a emissão.",
      "“A versão do evento recebido ainda não é suportada pelo validador fiscal (esperada: 1.01).”: o leiaute recebido precisa de análise de compatibilidade pelo suporte."
    ],
    "tips": [
      "Não crie outra nota para contornar uma falha de consulta."
    ],
    "related": [
      "Conferir emissão de NFS-e e conciliar uma DPS."
    ]
  },
  {
    "order": 200,
    "category": "Studio",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "id": "forms-catalog",
    "title": "Criar um formulário no Studio",
    "accessPath": "Studio → Formulários",
    "aliases": [
      "formulário",
      "formularios",
      "formulários",
      "novo formulário",
      "criar formulário",
      "grupos de campos"
    ],
    "questions": [
      "Como criar um formulário?",
      "Por que o formulário não salva?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Abra o construtor pelo catálogo de Formulários e crie uma estrutura com nome, grupos e campos válidos.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso a Studio → Formulários e permissão de gerenciamento."
    ],
    "steps": [
      "Abra “Studio → Formulários”.",
      "Clique em “Novo formulário” para abrir o construtor.",
      "Defina o nome do formulário e organize os grupos e campos desejados.",
      "Confira se cada grupo e campo possui nome e ID e se os campos apontam para grupos existentes.",
      "Salve o formulário e confira o retorno na listagem."
    ],
    "rules": [
      "O nome do formulário é obrigatório e não pode duplicar o de outro formulário existente.",
      "Grupos devem possuir nome e ID.",
      "IDs de grupos não podem se repetir.",
      "Campos devem possuir nome e ID.",
      "Um campo não pode referenciar um grupo inexistente.",
      "Criar um formulário não equivale a publicar um processo nem a conceder acesso público."
    ],
    "expectedResult": "Formulário salvo no catálogo com estrutura válida.",
    "errors": [
      "“Nome do formulário é obrigatório”: preencha o nome.",
      "“Formulário com esse nome já existe”: escolha outro nome ou edite o formulário existente.",
      "“Grupos devem possuir nome e id” ou “ID de grupo duplicado”: revise os grupos.",
      "“Campo referencia grupo inexistente”: corrija o vínculo do campo ao grupo."
    ],
    "tips": [],
    "related": []
  },
  {
    "order": 200,
    "category": "Inteligência",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "id": "nash-chat",
    "title": "Consultar procedimentos pela Nash IA",
    "accessPath": "Nash Chat → conversa com a Nash IA",
    "aliases": [
      "Nash IA",
      "Nash Chat",
      "assistente",
      "base de conhecimento",
      "manual do usuário",
      "procedimento"
    ],
    "questions": [
      "Como tirar dúvidas do sistema com a Nash IA?",
      "De onde vêm as respostas da Nash?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Pergunte pelo nome da tela e pela tarefa desejada. A Nash consulta procedimentos conferidos e disponíveis ao seu perfil.",
    "whenToUse": [],
    "prerequisites": [
      "Estar autenticado e conseguir abrir a conversa com a Nash IA."
    ],
    "steps": [
      "Abra a conversa com a Nash IA no Nash Chat.",
      "Informe o nome da tela e a ação desejada; por exemplo, “Como importar clientes por planilha?”.",
      "Leia o caminho, os passos, as condições e a referência do procedimento retornado.",
      "Se a Nash informar uma lacuna, detalhe a tela e a ação. Uma tarefa ainda não conferida precisa ser documentada antes de receber uma orientação oficial.",
      "Se a consulta estiver indisponível, tente novamente ou consulte “Configurações → Manual do usuário” e confira a situação do procedimento."
    ],
    "rules": [
      "Só procedimentos marcados como conferidos alimentam a consulta do backend.",
      "As referências são filtradas conforme o perfil; documentação não concede acesso a operações ou registros.",
      "Sem chave de IA ou em falha do provedor, um procedimento encontrado pode ser devolvido diretamente, com seus passos completos.",
      "A Nash recebe um trecho recente da própria conversa para interpretar continuações, dúvidas e correções.",
      "O histórico da conversa ajuda a entender a pergunta; as regras oficiais continuam vindo dos procedimentos conferidos.",
      "A consulta a procedimentos ou uma continuação como “sim” não significa que uma operação foi executada.",
      "Perguntas de dados ao vivo, ações, saudações e cálculos podem seguir o tratamento local já disponível.",
      "A documentação ainda em revisão não deve ser apresentada como regra confirmada do sistema."
    ],
    "expectedResult": "Orientação apoiada em um procedimento conferido, ou indicação explícita de que a informação não foi encontrada para o perfil.",
    "errors": [
      "“Não encontrei um procedimento conferido…”: detalhe a pergunta; se a tarefa não estiver coberta, ela precisa ser conferida e documentada.",
      "“Não consegui consultar a base de conhecimento agora…”: tente novamente ou abra o Manual do usuário."
    ],
    "tips": [],
    "related": []
  },
  {
    "order": 200,
    "category": "Solicitações",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "id": "new-request",
    "title": "Iniciar ou agendar uma nova solicitação",
    "accessPath": "Configurações → Minhas solicitações → Nova solicitação",
    "aliases": [
      "nova solicitação",
      "solicitação",
      "solicitacao",
      "iniciar agora",
      "agendar",
      "agendamento"
    ],
    "questions": [
      "Como iniciar uma nova solicitação?",
      "Como agendar uma solicitação?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Use o catálogo de Nova solicitação para iniciar um processo autorizado ou configurar seu agendamento.",
    "whenToUse": [],
    "prerequisites": [
      "Ter acesso a Minhas solicitações e autorização para executar o processo desejado.",
      "O processo precisa estar disponível no catálogo para sua conta."
    ],
    "steps": [
      "Abra “Configurações → Minhas solicitações”.",
      "Clique em “Nova solicitação”.",
      "Pesquise o processo desejado no catálogo e confira sua categoria e descrição.",
      "Para executar imediatamente, clique em “Iniciar agora” e prossiga no formulário aberto.",
      "Para programar a execução, escolha “Agendar”, preencha a configuração apresentada e use “Confirmar agendamento”."
    ],
    "rules": [
      "Iniciar agora e agendar são ações diferentes; escolher o processo não confirma automaticamente um agendamento.",
      "O catálogo e as ações disponíveis dependem das permissões e dos processos liberados.",
      "O procedimento de preenchimento e aprovação depende do formulário e do fluxo daquele processo; não existe uma regra de negócio única para todas as solicitações."
    ],
    "expectedResult": "Execução iniciada na aba do processo ou agendamento confirmado, conforme a ação escolhida.",
    "errors": [
      "Se o processo não aparecer, confira a busca e sua disponibilidade para o perfil.",
      "Se o agendamento for rejeitado, corrija a configuração indicada no retorno antes de confirmar novamente."
    ],
    "tips": [],
    "related": []
  },
  {
    "order": 200,
    "category": "Início",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "id": "profile-preferences",
    "title": "Atualizar Meu Perfil e trocar a senha",
    "accessPath": "Configurações → Meu Perfil",
    "aliases": [
      "meu perfil",
      "perfil",
      "trocar senha",
      "alterar senha",
      "senha atual",
      "notificações por e-mail"
    ],
    "questions": [
      "Como trocar minha senha?",
      "Posso alterar meu e-mail pelo perfil?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "Atualize seus dados pessoais permitidos, preferências e senha. Dados corporativos precisam ser alterados pela administração.",
    "whenToUse": [],
    "prerequisites": [
      "Estar autenticado e ter acesso a Meu Perfil.",
      "Para trocar a senha, conhecer a senha atual."
    ],
    "steps": [
      "Abra “Configurações → Meu Perfil”.",
      "Em “Atualizar perfil e acesso”, confira o nome completo e a data de nascimento.",
      "Ajuste a foto e a preferência de receber notificações por e-mail, se desejar.",
      "Para trocar a senha, preencha a senha atual, a nova senha e sua confirmação.",
      "Clique em “Salvar alterações”.",
      "Se a senha foi trocada, entre novamente: o sistema encerra a sessão por segurança."
    ],
    "rules": [
      "E-mail, CPF, grupo e setor são dados corporativos alterados por um administrador.",
      "O nome não pode ficar vazio.",
      "A nova senha deve ter pelo menos 8 caracteres e coincidir com a confirmação.",
      "A troca de senha exige a senha atual.",
      "Se houver troca obrigatória de senha, é preciso informar uma nova senha para continuar."
    ],
    "expectedResult": "Dados permitidos atualizados; na troca de senha, a sessão é encerrada para novo login.",
    "errors": [
      "“Informe um nome para continuar.”: preencha o nome.",
      "“Informe sua senha atual para definir uma nova senha.”: informe a senha atual.",
      "“As senhas digitadas não coincidem.”: confira a nova senha e sua confirmação."
    ],
    "tips": [],
    "related": []
  },
  {
    "id": "nash-conversation-history",
    "title": "Continuar uma conversa usando o histórico da Nash IA",
    "category": "Inteligência",
    "audience": "Usuários autenticados",
    "journeyStage": "Operação",
    "accessPath": "Nash Chat → conversa com a Nash IA",
    "order": 201,
    "aliases": [
      "histórico da Nash",
      "histórico da conversa",
      "memória da conversa",
      "continuar conversa",
      "limpar histórico"
    ],
    "questions": [
      "Como a Nash usa o histórico da conversa?",
      "Como limpar o histórico da Nash IA?",
      "Posso continuar a conversa depois de recarregar a página?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-02",
    "summary": "A Nash considera as perguntas e respostas recentes da própria conversa para entender continuações, detalhar uma orientação ou recapitular o assunto.",
    "whenToUse": [
      "Retomar o procedimento explicado na resposta anterior.",
      "Pedir uma explicação mais clara sem repetir toda a pergunta.",
      "Relembrar o que foi dito no trecho recente da conversa."
    ],
    "prerequisites": [
      "Estar autenticado na conta em que a conversa foi iniciada.",
      "Para retomar um assunto, existir histórico anterior disponível neste navegador."
    ],
    "steps": [
      "Abra a conversa com a Nash IA no Nash Chat e envie a pergunta inicial, identificando a tela e a tarefa desejada.",
      "Depois de receber a orientação, faça uma continuação, como “E depois?”, “Explique melhor” ou “Qual é o limite da planilha?”.",
      "Para relembrar o assunto, peça “Resuma nossa conversa” ou “O que eu perguntei?”.",
      "Se mudar de assunto, informe o nome da nova tela e da nova tarefa para evitar ambiguidade.",
      "Para recomeçar sem o contexto anterior, clique em “Limpar”, identificado como “Apagar histórico com a Nash IA”, e confirme."
    ],
    "rules": [
      "A conversa é mantida separadamente por usuário neste navegador, com até 200 mensagens locais; ela não é sincronizada entre dispositivos por este recurso.",
      "Cada próxima consulta recebe até 16 mensagens recentes, com orçamento total de 12.000 caracteres e até 3.000 por mensagem. A pergunta atual é enviada separadamente.",
      "Quando o trecho enviado não contiver uma informação antiga, a Nash não deve afirmar que consultou o início completo da conversa.",
      "Somente mensagens do usuário atual e da Nash nessa conversa compõem o contexto; conversas com outras pessoas não são incluídas.",
      "O histórico fornece contexto e preferências, sem substituir procedimentos oficiais nem conceder permissão para operações ou dados.",
      "As referências a procedimentos anteriores são novamente verificadas conforme as permissões atuais da conta.",
      "Limpar o histórico remove o contexto local das próximas consultas. Respostas pendentes são descartadas quando a conversa é limpa ou a conta muda.",
      "Uma continuação, como “sim”, não executa nem repete automaticamente uma ação anterior.",
      "Se o provedor de IA estiver indisponível, a orientação pode retornar pelo procedimento conferido; a recapitulação local mostra trechos atribuídos aos participantes."
    ],
    "expectedResult": "A próxima resposta usa o contexto recente da própria conversa e os procedimentos autorizados pertinentes, ou informa que falta contexto ou documentação.",
    "errors": [
      "“Não há mensagens anteriores disponíveis nesta conversa”: faça a pergunta inicial ou informe novamente o assunto.",
      "Se a Nash não identificar a referência, mencione o nome da tela e a tarefa; o assunto pode ter ficado fora do trecho recente.",
      "Se um procedimento antes disponível deixar de aparecer após uma mudança de perfil, confira o acesso atual com a administração."
    ],
    "tips": [
      "Mencione um campo, etapa ou mensagem de erro quando quiser esclarecer uma parte específica."
    ],
    "related": [
      "Consultar procedimentos pela Nash IA"
    ]
  },
  {
    "id": "young-apprentice-benefit-reports",
    "title": "Consultar os relatórios de VT e VA e configurar dias de curso",
    "category": "Gestão de Aprendiz",
    "audience": "Usuários com acesso aos relatórios de aprendiz",
    "journeyStage": "Operação",
    "accessPath": "Gestão de Aprendiz → Relatórios → Relatório de VT / Relatório de VA",
    "order": 230,
    "aliases": [
      "dias de VT",
      "dias de VA",
      "somente dias de curso",
      "vale-transporte",
      "vale-alimentação"
    ],
    "questions": [
      "Quem aparece nos relatórios de VT e VA?",
      "Como cobrar VT e VA somente no dia de curso?"
    ],
    "status": "verified",
    "verifiedAt": "2026-11-03",
    "summary": "- Consulte o valor diário multiplicado pelos dias elegíveis de VT ou VA, com exclusão de férias e feriados aplicáveis à empresa.",
    "whenToUse": [
      "Para conferir benefícios mensais e exportar resultados em PDF ou Excel."
    ],
    "prerequisites": [
      "Acesso ao relatório, módulo Jovem aprendiz habilitado e cadastro profissional com valor diário e datas válidos.",
      "Permissão de gerenciamento do cadastro para alterar Dias de VT e Dias de VA."
    ],
    "steps": [
      "No cadastro profissional, marque Cobrar VT ou Vale-alimentação como Sim para o benefício desejado.",
      "Informe o valor diário e escolha Dias úteis, Dias úteis + sábado ou Somente dias de curso no campo de dias de cada benefício.",
      "Para Somente dias de curso, informe um único dia da semana no Dia de curso e salve o cadastro.",
      "Abra o relatório correspondente, selecione a referência e, se necessário, a empresa, e clique em Buscar.",
      "Confira as datas e valores e utilize Excel ou Baixar PDF quando não houver pendências."
    ],
    "rules": [
      "Os relatórios exibem somente jovens com status ACTIVE no cadastro, em ordem alfabética pelo nome, inclusive nas exportações.",
      "O relatório de VT exige Cobrar VT = Sim; o relatório de VA exige Vale-alimentação = Sim. As opções são independentes.",
      "A referência respeita as datas dos vínculos profissionais. Períodos históricos de jovens ainda ativos são preservados e datas sobrepostas não são cobradas duas vezes.",
      "Somente dias de curso conta as ocorrências do dia da semana cadastrado dentro da referência e do período do vínculo, uma vez por semana. Férias e feriados são excluídos e não geram reposição em outro dia.",
      "O número mensal acompanha o calendário real, podendo variar conforme a quantidade de ocorrências do dia de curso.",
      "As escolhas de dias de VT e VA são independentes e também são usadas no cálculo automático das faturas.",
      "O valor mensal cadastrado não substitui o valor diário neste cálculo."
    ],
    "expectedResult": "- Uma linha por jovem ativo com o benefício habilitado, total calculado e detalhamento das datas, em ordem alfabética.",
    "errors": [
      "Informe um único dia de curso válido no cadastro profissional para calcular somente dias de curso.: preencha Dia de curso com um dia da semana e salve.",
      "Se houver pendência de valor diário ou datas, corrija o cadastro e clique em Buscar para liberar a exportação."
    ],
    "tips": [
      "Confira cada benefício separadamente, pois os dias e os valores podem ser diferentes."
    ],
    "related": [
      "Cadastro profissional no Mundo do Trabalho e cálculo automático de benefícios na Nota Fatura."
    ]
  }
];
